// The white and black (the black is really a dark grey) ['#FFFFFF,'#333333'] //
// The colors from color brewer: //
['#ffffd9','#edf8b1','#c7e9b4','#7fcdbb','#41b6c4','#1d91c0','#225ea8','#253494','#081d58']
// https://colorbrewer2.org/#type=sequential&scheme=YlGnBu&n=9

<template>
  <div id="haikubox" v-if="this.user != ''">
    <!-- notices -->
    <v-alert type="info" v-for="notice in userNotices" :key="notice.id">
      <v-row align="center">
        <v-col class="grow">
          {{ notice.noticeTitle }}
          {{ notice.noticeDescription }}
        </v-col>
        <v-col class="shrink">
          <v-btn @click="acknowledgeNotice(notice.id)">OK</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert type="info" @input="logClick('subscription', '', '')" dismissible v-if="showRenewAlert">
      <v-row align="center">
        <v-col class="grow">
          {{ t("Subscription Expired") }}
        </v-col>
      </v-row>
    </v-alert>

    <!-- Map -->
    <v-card
      class="mx-auto"
      max-width="100%"
      max-height="400"
      outlined
      v-if="showMap"
    >
      <div>
        <v-img height="100%" width="100%">
          <l-map
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            :bounds="bounds"
            style="height: 400px; width: 100%"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
            :maxZoom="maxZoomSummary"
          >
            <l-tile-layer :url="urlStates" :attribution="urlOceanAttribution" />
            <l-circle
              :key="haikuboxMarkerID"
              :lat-lng="[lat, lon]"
              :radius="currentHaikuboxRadius"
            >
            </l-circle>
            <v-marker-cluster :options="{ chunkedLoading: true }">
              <l-marker
                @click="
                  clickDevice(item, 1, false, item.shareLat, item.shareLon)
                "
                v-for="item in connectedDevices"
                :key="item.id"
                :lat-lng="[item.shareLat, item.shareLon]"
                :radius="2000"
                color="#0277BD"
              >
                <l-tooltip :options="{ permanent: true }">{{
                  item.name
                }}</l-tooltip>
              </l-marker>
            </v-marker-cluster>
          </l-map></v-img
        >
      </div>
    </v-card>

    <!-- Map Animation -->
    <!-- <v-card dark v-if="animationRunning">
      <div>
        <l-map
          style="height: 350px"
          :zoom="zoomSummary"
          :center="centerSummary"
          :maxZoom="maxZoomSummary"
        >
          <l-tile-layer :url="urlSummary" :attribution="attributionSummary" />
          <l-circle
            v-for="item in filterHourlySummary(summaryHour)"
            :key="item.id"
            :lat-lng="[item.lat, item.lon]"
            :radius="item.radius"
            :color="item.color"
          >
            <l-tooltip
              :options="{ sticky: true }"
              :content="item.name + ': ' + item.count"
            />
          </l-circle>
        </l-map>
      </div>
      <v-row>
        <v-col>
          <v-btn icon @click="startAnimation()"
            ><v-icon left>mdi-play-circle</v-icon></v-btn
          >
          <v-btn icon @click="stopAnimation()">
            <v-icon left>mdi-stop-circle</v-icon></v-btn
          >
          <v-card-text>{{ summaryHourLabel }} </v-card-text>
          <v-slider v-model="summaryHour" step="1" min="0" max="23"></v-slider> 
          <v-slider
            v-if="animationRunning == false"
            v-model="summaryHourIndex"
            step="1"
            min="0"
            max="23"
            @change="sliderSummaryHourIndex()"
          ></v-slider>
        </v-col>
        <v-col>
          <v-btn @click="toggleBasemap()">Basemap</v-btn>
          <v-btn @click="toggleColormap()"
            >Colormap {{ summaryColorMapIndex }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card> -->

    <!-- Haikubox Stats -->

    <v-card
      outlined
      height="200px"
      width="100%"
      v-if="
        (showMap == false) &
        (yesterdayCallsAndSongs == 0) &
        (showBadge == false)
      "
    >
      <v-img
        src="https://haikubox-images.s3.amazonaws.com/carousel/callOutBackground3.jpeg"
        height="100%"
        width="100%"
      >
        <v-row no-gutter>
          <v-col cols="9" class="py-1">
            <v-card-title style="word-break: break-word">
              {{ t("Welcome") }}
            </v-card-title></v-col
          >
          <v-col cols="3" class="d-flex align-center py-1">
            <v-icon dark>mdi-web</v-icon>
            <v-select
              :items="languages"
              v-model="selectedLanguage"
              @change="setLanguage(selectedLanguage)"
              dark
            ></v-select>
          </v-col>
        </v-row>
        <!-- <v-row class="mx-1"><v-col xs="4" sm="3"> </v-col></v-row> -->
      </v-img>
    </v-card>

    <v-card
      flat
      height="280px"
      width="100%"
      class="transparent px-0 mx-0 my-0 py-0"
      v-if="
        (showMap == false) & (yesterdayCallsAndSongs > 0) & (showBadge == false)
      "
    >
      <v-img
        src="https://haikubox-images.s3.amazonaws.com/carousel/callOutBackground3.jpeg"
        height="280px"
      >
        <v-row no-gutter>
          <v-col cols="9" class="py-1"
            ><v-card-title>{{ t("Yesterday") }}</v-card-title></v-col
          >
          <v-col cols="3" class="d-flex align-center py-1">
            <v-icon dark>mdi-web</v-icon>
            <v-select
              :items="languages"
              v-model="selectedLanguage"
              @change="setLanguage(selectedLanguage)"
              dark
            ></v-select>
          </v-col>
        </v-row>

        <v-row class="mx-1"
          ><v-col xs="4" sm="4" md="3" class="py-1">
            <v-card dark color="grey" tile>
              <v-card-title class="justify-center"
                >{{ yesterdayNumSpecies }}
              </v-card-title>
              <v-card-subtitle class="text-center">{{
                t("Species")
              }}</v-card-subtitle>
            </v-card>
          </v-col>
          <v-col xs="4" sm="4" md="3" class="py-1">
            <v-card dark color="grey" tile>
              <v-card-title class="justify-center"
                >{{ yesterdayCallsAndSongs }} </v-card-title
              ><v-card-subtitle class="text-center">
                {{ t("Calls and Songs") }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mx-1 my-2 py-4" align="center"
          ><v-col xs="8" sm="8" md="6" class="py-2">
            <v-card dark color="grey" tile>
              <v-row
                ><v-col cols="4" class="my-0">
                  <v-img
                    class="mx-2"
                    width="80%"
                    :src="
                      'https://haikubox-images.s3.amazonaws.com/' +
                      yesterdaySpCode +
                      '.jpeg'
                    "
                    onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                  ></v-img>
                </v-col>
                <v-col cols="7" class="py-2">
                  <v-card-title style="word-break: break-word">
                    {{
                      t(yesterdaySpCode, yesterdayMostFrequent)
                    }}</v-card-title
                  >
                  <v-card-subtitle
                    >{{ t("Most Frequent Visitor") }}
                    <!-- <v-btn
                      text
                      color="yellow"
                      @click="dailySummary()"
                      >More</v-btn
                    > -->
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-img>
    </v-card>

    <!-- Badges -->
    <v-card
      v-if="(showMap == false) & (showBadge == true)"
      height="280"
      light
      tile
      class="transparent mx-auto"
      width="100%"
      flat
    >
      <v-img
        src="https://haikubox-images.s3.amazonaws.com/carousel/callOutBackground1.jpeg"
        height="280px"
      >
        <v-card-title style="word-break: break-word">{{
          t("Progress and Badges")
        }}</v-card-title>
        <v-row style="height: 10px"></v-row>
        <v-row style="height: 20px"
          ><v-col cols="7"></v-col
          ><v-col cols="2"
            ><v-btn
              text
              class="white--text"
              height="40"
              width="40"
              v-if="totalLabeled > 0"
              >Level</v-btn
            ></v-col
          ></v-row
        >

        <v-card-text
          class="white--text text-xs-h6 text-sm-h5"
          v-if="totalLabeled == 0"
          >{{ t("Label bird detections to earn badges") }}</v-card-text
        >
        <div v-if="totalLabeled > 0">
          <v-row>
            <v-col cols="7">
              <v-progress-linear
                v-if="totalLabeled > 0"
                rounded
                :value="percentTargetLabeled"
                color="amber"
                height="40"
                class="mx-2 white--text"
                >{{ t("Labeled") }}: {{ totalLabeled }} / {{ targetLabel }}
              </v-progress-linear>
            </v-col>
            <v-col cols="2">
              <v-btn class="white--text" color="orange" height="40">
                {{ badgeLabelLevel }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="7">
              <v-progress-linear
                v-if="totalLabeled > 0"
                rounded
                :value="percentTargetLabelSpecies"
                color="orange"
                height="40"
                class="mx-2 my-1 white--text"
                >{{ t("Species") }}: {{ totalSpeciesLabeled }} /
                {{ targetLabelSpecies }}</v-progress-linear
              >
            </v-col>
            <v-col cols="2">
              <v-btn class="white--text" color="orange" height="40">
                {{ badgeLabelSpeciesLevel }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="7">
              <v-progress-linear
                v-if="totalLabeled > 0"
                rounded
                :value="percentTargetLabelStreak"
                height="40"
                class="mx-2 white--text"
                >{{ t("Streak") }}: {{ labelStreak }} / {{ targetLabelStreak }}
                {{ t("days") }}</v-progress-linear
              >
            </v-col>
            <v-col cols="2">
              <v-btn class="white--text" color="orange" height="40">
                {{ badgeLabelStreakLevel }}
              </v-btn>
            </v-col></v-row
          >
        </div>
      </v-img>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="100%"
      outlined
      color="blue-grey darken-4"
    >
      <!-- More Active Species  -->
      <!-- <v-card
        tile
        flat
        height="338"
        width="80%"
        class="transparent mx-auto"
      >
        <v-card-title class="my-6" style="word-break: break-word"
          >Singing levels are similar as previous day</v-card-title
        >
      </v-card> -->

      <!-- <v-card
        tile
        height="338"
        class="transparent"
      >
        <v-card-title>Increasing Activity</v-card-title>
        <v-container fluid>
          <v-row dense>
            <v-col
              cols="12"
              v-for="(item, index) in moreActiveSpeciesList"
              :key="item.id"
            >
              <v-card
                outlined
                color="light-grey darken-4"
                class="mx-auto"
                dark
                height="60"
                width="80%"
                max-width="500"
              >
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar
                      class="mx-2 my-1"
                      :href="
                        item.lon > -30
                          ? 'https://ebird.org/species/' + item.spCode
                          : 'https://www.allaboutbirds.org/guide/' +
                            replaceSpaces(item.cn)
                      "
                      target="_blank"
                    >
                      <v-img
                        width="60"
                        :src="
                          'https://haikubox-images.s3.amazonaws.com/' +
                          item.spCode +
                          '.jpeg'
                        "
                      ></v-img
                    ></v-avatar>
                  </v-col>
                  <v-col cols="6"> {{ item.cn }} </v-col>
                  <v-col cols="3">
                    <v-btn
                      icon
                      @click="
                        getWavFileName(
                          index,
                          item.spCode,
                          item.cn,
                          'Increasing',
                          'play',
                          ''
                        )
                      "
                    >
                      <v-icon>mdi-play-circle</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card> -->

      <!-- Header Info Section -->
      <v-row v-if="currentWiFi === 0 && isOwner">
        <v-col cols="12">
          <v-card dark class="px-2">
            <v-card-title style="word-break: break-word">
              {{ t("No WiFi") }}
            </v-card-title>
            <v-card-text class="my-0 py=0">{{ t("WiFi Step 1") }}</v-card-text>
            <v-card-text class="my-0 py=0">{{ t("WiFi Step 2") }}</v-card-text>
            <v-btn class="mx-2 my-2" @click="checkConnection(currentSerial)"
              >Check Connection</v-btn
            >
            <v-card-subtitle v-if="checkConnectionFailed"
              >{{ t("WiFi Check") }}
              {{ currentSerial }}
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" class="my-1 py-0">
          <v-card-title
            class="white--text text-no-wrap"
            style="word-break: break-word"
            v-if="haikuboxLoaded == 1"
          >
            <v-btn v-if="isOwner == true" color="white" icon  aria-hidden="true" tabindex="-1">
              <v-icon>mdi-home</v-icon>
            </v-btn>
            <v-btn
              v-if="
                (currentHaikuboxBookmark == false) &
                (isOwner == false) &
                (currentSiteName != '')
              "
              icon
              color="pink"
              @click="toggleHaikuboxBookmark()"
              v-tooltip.bottom-start="'Bookmark this Haikubox'"
            >
              <v-icon alt="bookmark">mdi-bookmark-multiple-outline</v-icon>
            </v-btn>
            <v-btn
              v-if="(currentHaikuboxBookmark == true) & (isOwner == false)"
              icon
              color="pink"
              @click="toggleHaikuboxBookmark()"
              v-tooltip.bottom-start="'Un-Bookmark this Haikubox'"
            >
              <v-icon alt="bookmark">mdi-bookmark-multiple</v-icon>
            </v-btn>
            {{ currentSiteName }}
          </v-card-title>
        </v-col>

        <v-col cols="2" class="my-1 d-flex justify-end" v-if="isOwner">
          <v-btn
            disabled
            icon
            v-if="currentWiFi >= -60 && currentWiFi != 0"
            dark
            @click="getStatus(currentSerial)"
            ><v-icon>mdi-signal-cellular-3</v-icon></v-btn
          >
          <v-btn
            disabled
            icon
            v-if="currentWiFi >= -74 && currentWiFi < -60"
            dark
            @click="getStatus(currentSerial)"
            ><v-icon>mdi-signal-cellular-2</v-icon></v-btn
          >
          <v-btn
            disabled
            icon
            v-if="currentWiFi >= -78 && currentWiFi < -74"
            dark
            @click="getStatus(currentSerial)"
            ><v-icon>mdi-signal-cellular-1</v-icon></v-btn
          >
          <v-btn
            disabled
            icon
            v-if="currentWiFi < -78"
            dark
            @click="getStatus(currentSerial)"
            ><v-icon>mdi-signal-cellular-outline</v-icon></v-btn
          >
        </v-col>
      </v-row>
      <v-row class="py-0 my-0">
        <v-col cols="12" class="py-0 my-0 px-10 d-flex justify-end">
          <!-- New Bird Alert -->
          <v-switch
            v-if="
              isOwner &
              goNativeActive &
              (currentView == 'Recent') &
              subscriptionActive
            "
            v-model="newBirdAlert"
            :label="t('New Bird Alerts')"
            @change="toggleNewBirdAlert(newBirdAlert)"
            dark
            color="info"
          ></v-switch> </v-col
      ></v-row>

      <!-- User window with App Bar -->
      <v-app-bar
        color="blue-grey darken-4"
        dark
        dense
        flat
        height="80px"
        v-if="
          ((devicesByOwner.length > 1) |
            ((devicesByOwner.length >= 0) & (bookmarkedDevices.length > 0))) &
          !showMap
        "
      >
        <v-select
          v-if="
            (devicesByOwner.length > 1) |
              ((devicesByOwner.length >= 0) & (bookmarkedDevices.length > 0))
          "
          v-model="haikuboxSelect"
          :items="devicesByOwner"
          item-text="name"
          item-value="serial"
          return-object
          @input="ownerSelectDevice()"
          dark
          class="mx-4"
          :label="t('Your Haikuboxes')"
        ></v-select>
        <v-select
          v-if="bookmarkedDevices.length > 0"
          v-model="bookmarkSelect"
          :items="bookmarkedDevices"
          item-text="name"
          item-value="id"
          return-object
          @input="bookmarkSelectDevice()"
          dark
          class="mx-4"
          :label="t('Bookmarks')"
        ></v-select>
      </v-app-bar>

      <!-- New Badges Alert -->
      <!-- <v-snackbar v-model="newLabelBadge" centered>
        You reached a labeling milestone! Thank you for helping make Haikubox
        better.
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="newLabelBadge = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar> -->

      <!-- <v-snackbar v-model="newLabelSpeciesBadge" centered>
        Species labeling milestone reached!
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="newLabelSpeciesBadge = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar> -->

      <!-- <v-snackbar v-model="newLabelStreakBadge" centered>
        Fantastic! New labeling streak!
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="newLabelStreakBadge = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar> -->

      <v-snackbar v-model="notifyBirdInfo" centered :timeout="60000">
        <v-icon>mdi-account</v-icon>
        {{ t("Notify Auth") }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="notifyBirdInfo = false"
          >
            No
          </v-btn>
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="grantOneSignalPrivacyConsent()"
          >
            Yes
          </v-btn>
        </template>
      </v-snackbar>

      <v-row
        ><v-col cols="6" class="white--text my-0 py-0 mx-4">
          <!-- Header for page viewing (Recent, All) -->
          <!-- Main Navigation Dropdown -->
          <v-select
            v-model="navSelection"
            :items="navList"
            item-text="text"
            item-value="id"
            return-object
            @input="changeView()"
            dark
            class="mx-4"
            :label="t('View')"
            ><template v-slot:item="{ item }">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template></v-select
          > </v-col
        ><v-col cols="5">
          <v-btn color="yellow" plain v-if="hitsLoading > 0">
            {{ t("Loading") }} {{ hitsLoading }}</v-btn
          >

          <!-- Refresh Button -->
          <v-btn
            v-if="(currentView === 'Recent') & (hitsLoading == 0) & isOwner"
            icon
            color="grey"
            @click="clickRefresh(currentSerial)"
            aria-label="Refresh"
          >
            <v-icon alt="refresh">mdi-refresh</v-icon>
            <!-- <router-link
            style="text-decoration: none; color: inherit"
            to="/haikubox"
            >
          </router-link> -->
          </v-btn>
          <!-- Calendar Picker -->
          <v-btn
            fab
            small
            v-if="
              (currentView === 'Recent') &
              (hitsLoading == 0) &
              isOwner &
              subscriptionActive &
              !hidePics
            "
            class="pa-1 ma-1"
            :color="recentHours == 0 ? 'blue lighten-2' : 'grey'"
            @click="hitSelectDate()"
            ><v-icon alt="calendar">mdi-calendar</v-icon>
          </v-btn>

          <!-- Volume Control -->
          <v-slider
            dark
            v-if="(hitsLoading == 0) & (!hidePics)"
            color="grey"
            class="px-2"
            v-model="playbackGain"
            prepend-icon="mdi-volume-high"
            prepend-icon-color="grey"
            min="50"
            max="200"
          ></v-slider> </v-col
      ></v-row>

      <template v-if="hitCalendarDatePicked == false">
        <v-row justify="center">
          <v-date-picker
            v-model="hitDatePicker"
            :min="minDate"
            :max="maxDate"
            @change="hitDateClick()"
          ></v-date-picker>
        </v-row>
      </template>

      <v-card-title
        v-if="currentView == 'Daily Summary'"
        class="grey--text my-0 py-0 subtitle-1"
        >{{ dailySummaryDate }}</v-card-title
      >
      <v-card-title
        v-if="(currentView == 'Recent') | (currentView == 'Live')"
        class="grey--text my-0 py-0 subtitle-1"
      >
        <div v-if="recentHours != 0">{{ lastUpdated }}</div>
        <div v-if="recentHours == 0">{{ hitDatePicker }}</div>

        <v-spacer></v-spacer>
        <!-- Buttons to control viewSettings confidence level for Recent -->
        <v-btn
          rounded
          x-small
          v-if="
            ((currentView === 'Recent') | (currentView === 'Live')) &
            (hitsLoading == 0)
          "
          class="pa-1 ma-1"
          :color="viewSettings == 'Low' ? 'blue lighten-2' : 'grey'"
          @click="setViewSettings('Low')"
          >{{ t("Low") }}
        </v-btn>
        <v-btn
          rounded
          x-small
          v-if="
            ((currentView === 'Recent') | (currentView === 'Live')) &
            (hitsLoading == 0)
          "
          class="pa-1 ma-1"
          :color="viewSettings == 'Medium' ? 'blue lighten-2' : 'grey'"
          @click="setViewSettings('Medium')"
          >{{ t("Med") }}
        </v-btn>
        <v-btn
          rounded
          x-small
          v-if="
            ((currentView === 'Recent') | (currentView === 'Live')) &
            (hitsLoading == 0)
          "
          class="pa-1 ma-1"
          :color="viewSettings == 'High' ? 'blue lighten-2' : 'grey'"
          @click="setViewSettings('High')"
          >{{ t("High") }}
        </v-btn>
        <v-dialog
          width="300"
          v-if="(currentView === 'Recent') | (currentView === 'Live')"
        >
          <template v-slot:activator="{ on, attrs }"  v-if="!hidePics">
            <v-btn
              icon
              color="yellow"
              v-bind="attrs"
              v-on="on"
              class="my-6 mx-3"
            >
              <v-icon alt="info">mdi-information</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="headline grey lighten-2">
              {{ t("View Settings") }}
            </v-card-title>
            <v-card-text>
              <v-list-item
                ><v-list-item-content>
                  {{ t("View Info") }}
                </v-list-item-content></v-list-item
              >
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-title>

      <!-- Recent -->
      <!-- Share dialog outside of for loop -->
      <v-dialog v-model="shareDialog" max-width="400">
        <v-card>
          <v-card-title class="text-h5 blue lighten-1 white--text">
            {{ t("Share") }}
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn tile class="white--text" text @click="shareDialog = false">
                {{ t("Close") }}
              </v-btn>
            </v-card-actions>
          </v-card-title>

          <!-- <v-btn
            v-if="goNativeActive == false"
            class="mx-2 my-4"
            color="primary"
            fab
            medium
            dark
            v-tooltip.bottom-start="'Download File'"
            :href="downloadLink"
            ><v-icon alt="download">mdi-download</v-icon>
          </v-btn> -->

          <v-divider></v-divider>
          <v-row no-gutters>
            <v-col cols="9">
              <v-text-field
                class="mx-2 my-6"
                :value="audioLink"
                readonly
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn @click="copyLink()" class="my-8">Copy</v-btn>
              <v-snackbar
                absolute
                shaped
                color="success"
                v-model="copyLinkSnackbar"
                :timeout="1000"
                icon="check_circle"
              >
                <v-icon>mdi-check</v-icon>
                {{ t("Copied") }}
              </v-snackbar>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- Recent card loop -->
      <v-container v-if="currentView == 'Recent'">
        <v-row dense>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="6"
            lg="4"
            xl="3"
            v-for="(item, index) in hits"
            :key="item.id"
          >
            <v-card
              color="light-blue darken-4"
              class="mx-auto mx-auto"
              style="word-break: break-word"
              dark
            >
            
            <div  v-if="hidePics"  tabindex="0"  :aria-label="t(item.spCode, item.cn)">
              {{t(item.spCode, item.cn)}}
            </div>


              <v-card-title v-if="!hidePics">{{ t(item.spCode, item.cn) }}</v-card-title>
              <v-card-subtitle class="font-italic" v-if="!hidePics">{{
                item.sn
              }}</v-card-subtitle>

              <v-row justify="end" class="px-8 my-0">
                <v-switch
                  v-if="isOwner & goNativeActive & subscriptionActive"
                  dense
                  class="mr-5 py-0"
                  v-model="item.notifyBird"
                  v-tooltip.bottom-start="
                    'Send notification when this species is detected'
                  "
                  label="Notify"
                  @change="
                    toggleNotifyBird(item.cn, item.spCode, item.notifyBird)
                  "
                  color="info"
                ></v-switch>

                <v-switch
                  dense
                  class="py-0"
                  v-if="isOwner"
                  v-model="item.showBird"
                  v-tooltip.bottom-start="
                    'Turning Show OFF will hide this species on M and H setting'
                  "
                  :label="t('Show')"
                  @change="toggleShowBird(item.cn, item.spCode, item.showBird)"
                  color="info"
                ></v-switch>
              </v-row>

              <!-- Recent Image -->
              <v-card-subtitle class="py-0">
                <img
                  width="100%"
                  v-if="item.window == 'image' & !hidePics"
                  :src="getImageUrl(item.spCode)"
                  onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                />

                <!-- Recent 24 Hour Donut Chart -->
                <div v-if="item.window == 'daily'">
                  <fusioncharts
                    type="doughnut2d"
                    width="100%"
                    height="240"
                    dataFormat="json"
                    :dataSource="item.hourlyCountPlotData"
                  >
                  </fusioncharts>
                </div>
                <!-- Recent 14 day heat map -->
                <div v-if="item.window == 'heatmap'">
                  <Plotly
                    :data="item.heatmap"
                    :display-mode-bar="false"
                    :layout="plotlyLayoutHeatmap"
                  ></Plotly>
                </div>

                <!-- Recent Daily Time Series -->
                <div v-if="item.window == 'monthly'">
                  <v-card-text class="ma-3"
                    ><v-icon>mdi-music-note</v-icon>
                    Past 3 Months

                    <!-- <span
                      class="font-weight-white"
                      v-text="getDailySpeciesCount(item.cn)"
                    ></span> -->
                  </v-card-text>
                  <column-chart
                    :colors="['#90A4AE']"
                    :height="300"
                    :library="{
                      scales: {
                        xAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                        yAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                      },
                    }"
                    :data="item.dailyCountPlotData"
                  ></column-chart>
                </div>

                <!-- Recent Spectrogram -->
                <div v-if="item.window == 'spectrogram'">
                  <Plotly
                    :data="item.spectrogram"
                    :layout="plotlyLayout"
                    :display-mode-bar="false"
                  ></Plotly>
                  <v-row no-gutters>
                    <v-col cols="1">0</v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1" class="d-flex justify-end">{{clipSeconds}}s</v-col>
                  </v-row>
                </div>

                <!-- Recent Map -->
                <div v-if="item.window == 'map'">
                  <l-map
                    :center="center"
                    :options="hitMapOptions"
                    :bounds="bounds"
                    style="height: 240px; width: 100%"
                    @update:center="centerUpdate"
                    @update:zoom="zoomUpdate"
                    :zoomControl="false"
                    :zoom="zoom"
                    :maxZoom="maxZoomHitMap"
                  >
                    <l-tile-layer
                      :url="urlStates"
                      :attribution="attributionSummary"
                    />
                    <l-circle
                      v-for="countPerHaikubox in item.map"
                      :key="countPerHaikubox.id"
                      :lat-lng="[countPerHaikubox.lat, countPerHaikubox.lon]"
                      :radius="countPerHaikubox.radius"
                      color="#0277BD"
                      fillColor="#039BE5"
                    />
                  </l-map>
                </div>
              </v-card-subtitle>

              <v-row class="my-0 py-0">
                <v-card-text class="my-0 py-0">
                  <v-btn
                    text
                    v-if="item.lon < -30"
                    @click="navigateTo('https://www.allaboutbirds.org/guide/' +
                            replaceSpaces(item.cn))"
                    color="light-blue"
                    >{{ t("About") }}</v-btn
                  >
                  <v-btn
                    text
                    @click="navigateTo('https://ebird.org/species/' + item.spCode)"
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-card-text>

                <v-spacer></v-spacer>
              </v-row>

              <!-- Recent Navigation -->
              <v-row class="mb-1" no-gutters v-if="!hidePics">
                <v-col cols="8">
                  <v-avatar
                    class="ml-4"
                    size="24"
                    v-tooltip.bottom-start="t('Image')"
                    @click="
                      setWindowRecent(index, 'image', item.spCode, item.cn)
                    "
                  >
                    <img
                      :width="$vuetify.breakpoint.xs ? '100%' : '320'"
                      :src="
                        'https://haikubox-images.s3.amazonaws.com/' +
                        item.spCode +
                        '.jpeg'
                      "
                      onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                    />
                  </v-avatar>

                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Hourly Chart')"
                    @click="
                      setWindowRecent(index, 'daily', item.spCode, item.cn)
                    "
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="hourly chart">mdi-chart-donut</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Daily Chart')"
                    @click="
                      setWindowRecent(index, 'monthly', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="daily chart">mdi-chart-bar</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Heat Map')"
                    @click="
                      setWindowRecent(index, 'heatmap', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="heat map">mdi-checkerboard</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Map')"
                    @click="setWindowRecent(index, 'map', item.spCode, item.cn)"
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="map">mdi-earth</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="t('Spectrogram')"
                    @click="
                      spectrogram(index, item.currentWav['filename'], 'Recent')
                    "
                  >
                    <v-icon alt="spectrogram">mdi-chart-bubble</v-icon>
                  </v-btn>
                </v-col>

                <v-spacer></v-spacer>

                <v-btn
                  v-tooltip.bottom-start="t('Share sound')"
                  @click="
                    shareLink(item.spCode, item.cn, item.currentWav['filename'])
                  "
                  color="light-blue darken-1"
                  @click.stop="shareDialog = true"
                  v-if="
                    isOwner || user === '9042f396-b3f9-49ec-b398-6c35bb29886a'
                  "
                  class="ml-0 mr-2"
                  >{{ t("Share") }}
                </v-btn>
              </v-row>

              <!-- Recent Play -->
              <div>
                <v-card-actions class="mx-0 my-0 py-0">
                  <v-row
                    ><v-col cols="12">
                      <v-btn
                        class="mx-1 my-1"
                        @click="
                          playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            index,
                            false
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Play")}}
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        @click="
                          playFileEnhance(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item.id,
                            item
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Enhance") }}
                      </v-btn>
                      </v-col
                    >
                      
                    <v-col cols="12">
                      <v-select
                        class="mx-2 my-0 py-0"
                        :items="item.wavList"
                        v-model="item.currentWav"
                        item-text="listname"
                        item-value="filename"
                        @change="
                          playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            index,
                            true
                          )
                        "
                        return-object
                        single-line
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-card-actions>
                <v-card-actions class="mx-0 my-0 py-0">
                  <v-row align="center" justify="center" no-gutter>
                    <v-col cols="12">
                      
                      <v-btn
                        v-if="isOwner & subscriptionActive"
                        class="mx-1 my-0"
                        @click="favoriteHit(item)"
                        color="light-blue darken-1"
                      >
                        <v-icon left>{{
                          item.favoriteHit ? "mdi-star" : "mdi-star-outline"
                        }}</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Favorite") }}
                      </v-btn>
                      <v-btn
                        v-if="goNativeActive == false & isOwner & subscriptionActive"
                        class="mx-2 my-0"
                        color="light-blue darken-1"
                        fab
                        small
                        dark
                        v-tooltip.bottom-start="'Download'"
                        @click="download(item)"
                        ><v-icon alt="download">mdi-download</v-icon>
                      </v-btn>

                      <!-- Minus Button -->
                      <v-btn v-if="maxClipSeconds > 3" class="mx-1" :style="{ minWidth: '40px', height: '32px', padding: '0 8px' }" color="light-blue darken-1" @click="clipSeconds > 3 ? clipSeconds-- : clipSeconds">
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>

                        <!-- Plus Button -->
                        <v-btn v-if="maxClipSeconds > 3" :style="{ minWidth: '40px', height: '32px', padding: '0 8px' }" color="light-blue darken-1" @click="clipSeconds < maxClipSeconds ? clipSeconds++ : clipSeconds">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <span v-if="maxClipSeconds > 3" :style="{ minWidth: '40px', height: '32px', padding: '0 8px' }" color="grey lighten-1">{{ clipSeconds }}s</span>
                    


                    </v-col>
                  </v-row>
                </v-card-actions>

                <!-- Recent Label -->
                <v-row no-gutters v-if="isOwner & !hidePics"
                  ><v-col cols="10">
                    <v-overflow-btn
                      class="mx-3 my-2"
                      v-if="item.wav"
                      @change="labelHit(index, item)"
                      :items="dropdown_class"
                      :background-color="
                        item.classLabel != null
                          ? 'light-blue darken-4'
                          : 'light-blue darken-1'
                      "
                      :label="labelText(item.spCode, item.cn)"
                      :aria-label="labelText(item.spCode, item.cn)" 
                      target="#label_sound"
                      v-model="item.classLabel"
                    ></v-overflow-btn>

                    <v-text-field
                      v-if="item.showEntryBox == true"
                      counter="50"
                      maxlength="50"
                      v-model="item.tellUsMore"
                      :placeholder="t('What is this sound?')"
                      :label="t('This sound is a:')"
                      outlined
                      :hint="item.submitted == true ? t('Submitted') : ''"
                      persistent-hint
                    >
                    </v-text-field>

                    <v-btn
                      v-if="item.showSubmitBox == true"
                      @click="labelHitCustom(index, item)"
                      class="ma-2"
                      color="light-blue darken-1"
                      >{{ t("Submit") }}</v-btn
                    >
                  </v-col>
                  <v-col cols="2">
                    <v-dialog width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" class="my-6 mx-3" v-if="!hidePics">
                          <v-icon alt=" labeling information"
                            >mdi-information</v-icon
                          >
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title class="headline grey lighten-2">
                          {{ t("About Labeling") }}
                        </v-card-title>

                        <v-card-text>
                          {{ t("Label Info") }}
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- Live Detections -->
      <v-container fluid v-if="currentView == 'Live'">
        <v-row dense>
          <v-col cols="12" v-for="item in liveHits" :key="item.id">
            <v-card outlined tile color="black" dark>
              <v-row align="center">
                <v-col cols="3" align="center">
                  <v-img
                    v-if = "!hidePics"
                    width="100%"
                    max-width="120"
                    :src="
                      'https://haikubox-images.s3.amazonaws.com/' +
                      item.spCode +
                      '.jpeg'
                    "
                    onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                  ></v-img>

                </v-col>

                <v-col cols="3"> {{ t(item.spCode, item.cn) }}
                  <v-card-text class="my-0 py-0">
                  <v-btn
                    v-if="(!goNativeActive)"
                    text
                    @click="navigateTo('https://ebird.org/species/' + item.spCode)"
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-card-text>
                </v-col>
                
                <v-col cols="3" align="right"> {{ getEventText(item) }} </v-col>
                <v-col cols="3" align="center">
                  <v-btn
                    icon
                    v-tooltip.bottom-start="t('Play')"
                    @click="
                      playFile(
                        item.wav,
                        item.spCode,
                        item.cn,
                        item,
                        null,
                        false
                      )
                    "
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-1"
                    v-tooltip.bottom-start="t('Enhance')"
                    @click="
                      playFileEnhance(item.wav, item.spCode, item.cn, item.id, item)
                    "
                    color="light-blue darken-1"
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <!-- <div v-if="item.window == 'spectrogram'">
                <Plotly
                  :data="item.spectrogram"
                  :layout="plotlyLayout"
                  :display-mode-bar="false"
                ></Plotly>
              </div> -->
            </v-card>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-card-title class="white--text">Past Hour</v-card-title>
          <v-col
            cols="12"
            v-for="(item, index2) in allHits.slice(0, 100)"
            :key="item.id"
          >
            <v-card dark tile color="#385F73">
              <v-row dense align="center">
                <v-col cols="3" align="center">
                  <v-img
                    v-if = "!hidePics"
                    width="100%"
                    max-width="120"
                    :src="
                      'https://haikubox-images.s3.amazonaws.com/' +
                      item.spCode +
                      '.jpeg'
                    "
                    onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                  ></v-img>
                </v-col>
                <v-col cols="3" align="left">
                  {{ index2 + 1 }}. {{ t(item.spCode, item.cn) }}
                  <v-card-text class="my-0 py-0">
               
                  <v-btn
                    v-if="(item.lon < -30) & (!goNativeActive)"
                    text
                    @click="navigateTo('https://ebird.org/species/' + item.spCode)"
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-card-text>
                </v-col>
                <v-col cols="3" align="right">
                  {{ getEventText(item) }}
                </v-col>
                <v-col cols="3" align="center">
                  <v-btn
                    icon
                    v-tooltip.bottom-start="t('Play')"
                    v-if="item.wav"
                    @click="
                      playFile(
                        item.wav,
                        item.spCode,
                        item.cn,
                        item,
                        null,
                        false
                      )
                    "
                    ><v-icon>mdi-play-circle</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    v-tooltip.bottom-start="t('Enhance')"
                    class="mx-1"
                    @click="
                      playFileEnhance(item.wav, item.spCode, item.cn, item.id, item)
                    "
                    color="light-blue darken-1"
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- All -->
      <v-container v-if="currentView == 'All'" fluid>
        <template>
          <v-row>
            <v-col class="text-left mx-5">
              <v-autocomplete
                dark
                :items="allSpeciesList"
                :label="t('Select Species')"
                v-model="speciesSelected"
                @change="selectSpecies(speciesSelected)"
                auto-select-first
              ></v-autocomplete>
            </v-col>
            <v-dialog v-model="csvDialog" persistent max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-col class="text-right">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    {{ t("Download CSV") }}
                  </v-btn>
                </v-col>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Download CSV</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-checkbox
                          dense
                          v-model="downloadSummary"
                          :label="t('Download Summary')"
                        ></v-checkbox>
                        <v-checkbox
                          dense
                          v-model="downloadRaw"
                          :label="t('DownloadInfo')"
                        ></v-checkbox>
                      </v-col>

                      <v-col cols="12" v-if="downloadRaw == true">
                        <v-date-picker
                          v-model="csvDates"
                          range
                          no-title
                        ></v-date-picker>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="csvDialog = false">
                    {{ t("Close") }}
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="downloadCSV()">
                    {{ t("Download CSV") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <!-- ALL Loop through all species -->
        <v-row dense>
          <v-col
            cols="12"
            v-for="(item, index) in seriesDaily"
            :key="item.id"
            :id="t(item.spCode, item.cn)"
          >
            <v-card
              tile
              outlined
              color="light-blue darken-4"
              class="mx-auto mx-auto"
              dark
              scroll-margin-top="50px"
            >   
              <v-row no-gutters>
                <v-col cols="2">
                  <v-img
                    v-if = "!hidePics"
                    class="mx-1 my-1"
                    width="80%"
                    max-width="120"   
                    :src="
                      'https://haikubox-images.s3.amazonaws.com/' +
                      item.spCode +
                      '.jpeg'
                    "
                    onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                  ></v-img>
                </v-col>

                <v-col cols="5">
                  {{ index + 1 }}. {{ t(item.spCode, item.cn) }}
                  {{ item.countsTotal }}
                </v-col>

                <v-col cols="5">
                  <v-btn
                    v-if="!hidePics"
                    icon
                    v-tooltip.bottom-start="t('Daily Chart')"
                    @click="
                      setWindowAll(index, 'monthly', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="daily chart">mdi-chart-multiple</v-icon>
                  </v-btn>
                  <!-- <v-btn
                    v-if="!hidePics"
                    icon
                    v-tooltip.bottom-start="t('Spectrogram')"
                    @click="
                      getWavFileName(
                        index,
                        item.spCode,
                        item.cn,
                        'All',
                        'spectrogram',
                        item.wav
                      )
                    "
                  >
                    <v-icon alt="spectrogram">mdi-chart-bubble</v-icon>
                  </v-btn> -->
                  <!-- <v-btn
                    icon
                    v-tooltip.bottom-start="'Download File'"
                    :href="downloadLink"
                    v-if="isOwner"
                    ><v-icon>mdi-download</v-icon>
                  </v-btn> -->
                  <!-- <v-btn
                    icon
                    v-tooltip.bottom-start="t('Play')"
                    @click="
                      getWavFileName(
                        index,
                        item.spCode,
                        item.cn,
                        'All',
                        'play',
                        item.wav
                      )
                    "
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                  </v-btn> -->
                  <!-- <v-btn
                    icon
                    class="mx-1"
                    v-tooltip.bottom-start="t('Enhance')"
                    @click="
                      playFileEnhance(item.wav, item.spCode, item.cn, item.id, item)
                    "
                    color="light-blue darken-1"
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                  </v-btn> -->
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="d-flex align-center">
                    <v-btn
                    text
                    style="height: 12px; margin: 0; padding: 0; margin-left: 2px; margin-right: 1px;"
                    v-if="item.lon < -30"
                    @click="navigateTo('https://www.allaboutbirds.org/guide/' +
                            replaceSpaces(item.cn))"
                    color="light-blue"
                    >{{ t("About") }}
                    </v-btn
                  >
                  <v-btn
                    text
                    style="height: 12px;margin: 0; padding: 0; margin-left: 0px; margin-right: 10px;"
                    @click="navigateTo('https://ebird.org/species/' + item.spCode)"
                    color="light-blue"
                    >eBird</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-switch
                    v-if="isOwner"
                    v-model="item.showBird"
                    v-tooltip.bottom-start="
                      'Turning Show OFF will hide this species on M and H setting'
                    "
                    :label="t('Show')"
                    @change="
                      toggleShowBird(item.cn, item.spCode, item.showBird)
                    "
                    color="info"
                    style="margin: 0; padding: 0; margin-left: 8px; margin-right: 8px;"
                  ></v-switch>
                  
                  <v-switch
                    v-if="isOwner & goNativeActive & subscriptionActive"
                    v-model="item.notifyBird"
                    v-tooltip.bottom-start="
                      'Send notification when this species is detected'
                    "
                    :label="t('Notify')"
                    @change="
                      toggleNotifyBird(item.cn, item.spCode, item.notifyBird)
                    "
                    color="info"
                    style="margin: 0; padding: 0; margin-right: 16px;"
                  ></v-switch>
                    
                 
                </div>


                 

                </v-col>
              </v-row>

              <!-- All Daily Time Series -->
              <div v-if="item.window == 'monthly'">
                <!-- <v-card-text class="ma-3">
                  <v-icon>mdi-music-note</v-icon
                  >{{ item.countsTotal }}</v-card-text
                > -->
                <fusioncharts
                  width="100%"
                  height="300"
                  type="timeseries"
                  dataFormat="json"
                  :dataSource="item.dataSource"
                >
                </fusioncharts>
              </div>

              <!-- All Spectrogram -->
              <div v-if="item.window == 'spectrogram'">
                <Plotly
                  :data="item.spectrogram"
                  :layout="plotlyLayout"
                  :display-mode-bar="false"
                ></Plotly>
              </div>

              <!-- <div v-if="item.wav">
                  <v-card-actions>
                    <v-btn @click="playFile(item.wav, item.spCode, item.cn)" color="light-blue darken-1">
                      <v-icon class="mx-1" small align="center">mdi-play-circle</v-icon>
                      {{t("Play")}}
                    </v-btn>
                    <v-slider class="px-3" v-model="playbackGain" prepend-icon="mdi-volume-high" min="20" max="60"></v-slider>
                  </v-card-actions>
                </div> -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- Yesterday Daily Summary -->
      <v-container v-if="currentView == 'Yesterday'" fluid>
        <v-row dense>
          <v-col
            cols="12"
            v-for="(item, index) in dailySummaryList"
            :key="item.id"
          >
            <v-card
              tile
              outlined
              color="light-blue darken-4"
              class="mx-auto my-auto"
              dark
            >
              <v-row no-gutters align="center">
                <v-col cols="3">
                  <v-img
                    v-if="!hidePics"
                    class="mx-2 my-3"
                    width="85%"
                    max-width="120"
                    :src="
                      'https://haikubox-images.s3.amazonaws.com/' +
                      item.spCode +
                      '.jpeg'
                    "
                    onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                  ></v-img>
                </v-col>

                <v-col cols="4">
                  {{ index + 1 }}. {{ t(item.spCode, item.cn) }}
                  {{ item.countsPerDay }}
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-btn
                    class="mx-1 my-1"
                    @click="
                      getWavFileName(
                        index,
                        item.spCode,
                        item.cn,
                        'Daily Summary',
                        'play',
                        item.wav
                      )
                    "
                    color="light-blue darken-1"
                    ><v-icon left>mdi-play-circle</v-icon>
                    <v-divider class="mx-1" vertical></v-divider>
                    {{ t("Play") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mx-1 my-2"
                    @click="
                      playFileEnhance(item.wav, item.spCode, item.cn, item.id, item)
                    "
                    color="light-blue darken-1"
                  >
                    <v-icon left>mdi-play-circle</v-icon>
                    <v-divider class="mx-1" vertical></v-divider>
                    {{ t("Enhance") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters align="center"
                ><v-col cols="8">
                  <v-btn
                    text
                    v-if="item.lon < -30"
                    @click="navigateTo('https://www.allaboutbirds.org/guide/' +
                            replaceSpaces(item.cn))"
                    color="light-blue"
                    >{{ t("About") }}</v-btn
                  >
                  <v-btn
                    text
                    @click="navigateTo('https://ebird.org/species/' + item.spCode)"
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-col>
              </v-row>

              <!-- All Daily Time Series -->
              <div v-if="item.window == 'monthly'">
                <v-card-text class="ma-3">
                  <v-icon>mdi-music-note</v-icon
                  >{{ item.countsTotal }}</v-card-text
                >
                <fusioncharts
                  width="100%"
                  height="300"
                  type="timeseries"
                  dataFormat="json"
                  :dataSource="item.dataSource"
                >
                </fusioncharts>
              </div>

              <!-- All Spectrogram -->
              <div v-if="item.window == 'spectrogram'">
                <Plotly
                  :data="item.spectrogram"
                  :layout="plotlyLayout"
                  :display-mode-bar="false"
                ></Plotly>
              </div>

              <!-- <div v-if="item.wav">
                  <v-card-actions>
                    <v-btn @click="playFile(item.wav, item.spCode, item.cn)" color="light-blue darken-1">
                      <v-icon class="mx-1" small align="center">mdi-play-circle</v-icon>
                      Play
                    </v-btn>
                    <v-slider class="px-3" v-model="playbackGain" prepend-icon="mdi-volume-high" min="20" max="60"></v-slider>
                  </v-card-actions>
                </div> -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- Haiku Poem -->
    <v-card light tile flat color="rgb(255, 255, 255, 0.6)">
      <v-img :src="haiku.src">
        <v-row style="height: 10px"></v-row>
        <v-row style="height: 40px">
          <v-col class="mx-6 my-2" cols="12">
            <v-card-text
             role="none"
              class="mx-6 text-xs-h6 text-sm-h5 mx-sm-5"
              style="color: black; text-align: left; text-indent: 20%;"
               :aria-label="haiku.poem1"
               tabindex="0"
            >
              {{ haiku.poem1 }}</v-card-text
            >
          </v-col>
        </v-row>
        <v-row style="height: 40px">
          <v-col class="mx-6 my-1" cols="12">
            <v-card-text
              class="mx-6 text-xs-h6 text-sm-h5 mx-sm-5"
              style="color: black; text-align: left; text-indent: 20%;"
              :aria-label="haiku.poem2"
               tabindex="0"
              >{{ haiku.poem2 }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row style="height: 40px">
          <v-col class="mx-6 my-1" cols="12">
            <v-card-text
              class="mx-6 text-xs-h6 text-sm-h5 mx-sm-5"
              style="color: black; text-align: left; text-indent: 20%;"
              :aria-label="haiku.poem3"
               tabindex="0"
            >
              {{ haiku.poem3 }}</v-card-text
            >
          </v-col>
        </v-row>

        <v-row style="height: 2px"></v-row>

        <v-row style="height: 50px"
          ><v-col xs="2" sm="4"> </v-col
          ><v-col xs="10" sm="8">
            <v-card-text class="text-xs-h6 text-sm-h5" style="color: black; text-align: left; " :aria-label="haiku.poemAuthor"
            tabindex="0">
              {{ haiku.poemAuthor }}
            </v-card-text>
            
          </v-col></v-row
        >
        <v-row style="height: 60px"
          ><v-col xs="2" sm="4"> </v-col
          ><v-col xs="10" sm="8">
          </v-col></v-row
        >
      </v-img>
    </v-card>

    <!-- Snackbar No Audio -->
    <v-snackbar v-model="snackbar">
      Audio unavailable
      <template v-slot:action="{ attrs }">
        <v-btn color="yellow" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Bottom Navigation -->
    <v-bottom-navigation hide-on-scroll fixed horizontal dark height="60">
      <v-btn v-if="showBirdCastButton()" @click=navigateTo(birdCastUrl)>
        <span>Birdcast</span>
        <v-icon alt="Birdcast link">mdi-earth</v-icon>
      </v-btn>
      <v-btn
        @click="
          $vuetify.goTo(0, {
            duration: 300,
            offset: 0,
            easing: 'easeInOutCubic',
          })
        "
      >
        <span>To Top</span>
        <v-icon alt="Go to top of page">mdi-pan-up</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script
  async
  defer
  crossorigin="anonymous"
></script>

<script>
import { API, Storage } from "aws-amplify";
import {
  hitBySerialByDate,
  statusByDate,
  getDeviceState,
  dailyCountSummaryBySerialBySpecies,
  dailyCountSummaryBySerialByDate,
  yearlyCountSummaryBySerialByYear,
  getUserInteraction,
  dailyCountSummaryByDateBySpecies,
  getDailyCountSummary,
  listShareMaps,
  haikuboxByOwner,
  hideBirdBySerial,
  notifyBirdBySerial,
  getOneSignalConsent,
  bookmarkHaikuboxByOwner,
  getShareMap,
  getBookmarkHaikubox,
  getDevice,
  hitsBySpeciesByDate,
  userNoticeByOwnerByViewed,
  getNoticeDescription,
  getSubscription,
  getFavoriteHit,
  getUserSettings
} from "./graphql/queries";
import {
  createLabeledData,
  createUserInteraction,
  updateUserInteraction,
  createClickTable,
  deleteHideBird,
  createHideBird,
  deleteNotifyBird,
  createNotifyBird,
  createOneSignal,
  createOneSignalConsent,
  updateDevice,
  deleteBookmarkHaikubox,
  createBookmarkHaikubox,
  updateUserNotice,
  createFavoriteHit,
  deleteFavoriteHit,
} from "./graphql/mutations";
import { latLngBounds, latLng, icon } from "leaflet";
import { LCircle, LTooltip } from "vue2-leaflet";
// import terminator from '@joergdietrich/leaflet.terminator';

import FusionCharts from "fusioncharts";

import { Plotly } from "vue-plotly";
var moment = require("moment-timezone");

var fft = require("fft-js").fft,
  ifft = require("fft-js").ifft;

// https://github.com/chrisguttandin/standardized-audio-context
import { AudioContext, decodeAudioData } from "standardized-audio-context";
//const AudioContext = window.AudioContext || window.webkitAudioContext;

var hann = [
  0.0, 3.77965773e-5, 1.51180595e-4, 3.4013491e-4, 6.04630957e-4, 9.44628746e-4,
  1.36007687e-3, 1.85091253e-3, 2.41706151e-3, 3.05843822e-3, 3.77494569e-3,
  4.56647559e-3, 5.43290826e-3, 6.3741127e-3, 7.38994662e-3, 8.48025644e-3,
  9.64487731e-3, 1.08836332e-2, 1.21963367e-2, 1.35827895e-2, 1.50427819e-2,
  1.65760932e-2, 1.81824916e-2, 1.98617342e-2, 2.16135671e-2, 2.34377255e-2,
  2.53339336e-2, 2.73019047e-2, 2.93413412e-2, 3.1451935e-2, 3.36333667e-2,
  3.58853068e-2, 3.82074146e-2, 4.05993391e-2, 4.30607187e-2, 4.55911813e-2,
  4.81903443e-2, 5.08578147e-2, 5.35931893e-2, 5.63960544e-2, 5.92659864e-2,
  6.22025514e-2, 6.52053053e-2, 6.82737943e-2, 7.14075543e-2, 7.46061116e-2,
  7.78689827e-2, 8.11956742e-2, 8.45856832e-2, 8.80384971e-2, 9.1553594e-2,
  9.51304424e-2, 9.87685015e-2, 1.02467221e-1, 1.06226043e-1, 1.10044397e-1,
  1.13921708e-1, 1.17857388e-1, 1.21850843e-1, 1.25901469e-1, 1.30008654e-1,
  1.34171776e-1, 1.38390206e-1, 1.42663307e-1, 1.46990432e-1, 1.51370928e-1,
  1.55804131e-1, 1.60289372e-1, 1.64825973e-1, 1.69413247e-1, 1.74050502e-1,
  1.78737036e-1, 1.8347214e-1, 1.88255099e-1, 1.9308519e-1, 1.97961681e-1,
  2.02883837e-1, 2.07850913e-1, 2.12862158e-1, 2.17916814e-1, 2.23014117e-1,
  2.28153297e-1, 2.33333576e-1, 2.38554171e-1, 2.43814294e-1, 2.49113148e-1,
  2.54449933e-1, 2.59823842e-1, 2.65234062e-1, 2.70679775e-1, 2.76160159e-1,
  2.81674384e-1, 2.87221617e-1, 2.92801019e-1, 2.98411747e-1, 3.04052952e-1,
  3.09723782e-1, 3.15423378e-1, 3.21150881e-1, 3.26905422e-1, 3.32686134e-1,
  3.38492141e-1, 3.44322565e-1, 3.50176526e-1, 3.56053138e-1, 3.61951513e-1,
  3.6787076e-1, 3.73809982e-1, 3.79768282e-1, 3.8574476e-1, 3.91738511e-1,
  3.97748631e-1, 4.03774209e-1, 4.09814335e-1, 4.15868096e-1, 4.21934577e-1,
  4.2801286e-1, 4.34102027e-1, 4.40201156e-1, 4.46309327e-1, 4.52425614e-1,
  4.58549094e-1, 4.64678841e-1, 4.70813928e-1, 4.76953428e-1, 4.83096412e-1,
  4.89241951e-1, 4.95389117e-1, 5.0153698e-1, 5.07684611e-1, 5.1383108e-1,
  5.19975458e-1, 5.26116815e-1, 5.32254225e-1, 5.38386758e-1, 5.44513487e-1,
  5.50633486e-1, 5.56745831e-1, 5.62849596e-1, 5.68943859e-1, 5.75027699e-1,
  5.81100196e-1, 5.87160431e-1, 5.93207489e-1, 5.99240456e-1, 6.05258418e-1,
  6.11260467e-1, 6.17245695e-1, 6.23213197e-1, 6.2916207e-1, 6.35091417e-1,
  6.41000339e-1, 6.46887944e-1, 6.52753341e-1, 6.58595644e-1, 6.6441397e-1,
  6.70207439e-1, 6.75975174e-1, 6.81716305e-1, 6.87429962e-1, 6.93115283e-1,
  6.98771407e-1, 7.0439748e-1, 7.09992651e-1, 7.15556073e-1, 7.21086907e-1,
  7.26584315e-1, 7.32047467e-1, 7.37475536e-1, 7.42867702e-1, 7.4822315e-1,
  7.5354107e-1, 7.58820659e-1, 7.64061117e-1, 7.69261652e-1, 7.74421479e-1,
  7.79539817e-1, 7.84615893e-1, 7.89648938e-1, 7.94638193e-1, 7.99582902e-1,
  8.04482319e-1, 8.09335702e-1, 8.14142317e-1, 8.18901439e-1, 8.23612347e-1,
  8.28274329e-1, 8.32886681e-1, 8.37448705e-1, 8.41959711e-1, 8.46419017e-1,
  8.5082595e-1, 8.55179843e-1, 8.59480037e-1, 8.63725883e-1, 8.67916738e-1,
  8.7205197e-1, 8.76130952e-1, 8.80153069e-1, 8.84117711e-1, 8.88024281e-1,
  8.91872186e-1, 8.95660845e-1, 8.99389686e-1, 9.03058145e-1, 9.06665667e-1,
  9.10211707e-1, 9.13695728e-1, 9.17117204e-1, 9.20475618e-1, 9.23770461e-1,
  9.27001237e-1, 9.30167455e-1, 9.33268638e-1, 9.36304317e-1, 9.39274033e-1,
  9.42177336e-1, 9.45013788e-1, 9.4778296e-1, 9.50484434e-1, 9.531178e-1,
  9.55682662e-1, 9.5817863e-1, 9.60605328e-1, 9.62962389e-1, 9.65249456e-1,
  9.67466184e-1, 9.69612237e-1, 9.71687291e-1, 9.73691033e-1, 9.75623159e-1,
  9.77483377e-1, 9.79271407e-1, 9.80986977e-1, 9.82629829e-1, 9.84199713e-1,
  9.85696393e-1, 9.87119643e-1, 9.88469246e-1, 9.89745e-1, 9.90946711e-1,
  9.92074198e-1, 9.9312729e-1, 9.94105827e-1, 9.95009663e-1, 9.9583866e-1,
  9.96592693e-1, 9.97271648e-1, 9.97875422e-1, 9.98403924e-1, 9.98857075e-1,
  9.99234805e-1, 9.99537058e-1, 9.99763787e-1, 9.99914959e-1, 9.99990551e-1,
  9.99990551e-1, 9.99914959e-1, 9.99763787e-1, 9.99537058e-1, 9.99234805e-1,
  9.98857075e-1, 9.98403924e-1, 9.97875422e-1, 9.97271648e-1, 9.96592693e-1,
  9.9583866e-1, 9.95009663e-1, 9.94105827e-1, 9.9312729e-1, 9.92074198e-1,
  9.90946711e-1, 9.89745e-1, 9.88469246e-1, 9.87119643e-1, 9.85696393e-1,
  9.84199713e-1, 9.82629829e-1, 9.80986977e-1, 9.79271407e-1, 9.77483377e-1,
  9.75623159e-1, 9.73691033e-1, 9.71687291e-1, 9.69612237e-1, 9.67466184e-1,
  9.65249456e-1, 9.62962389e-1, 9.60605328e-1, 9.5817863e-1, 9.55682662e-1,
  9.531178e-1, 9.50484434e-1, 9.4778296e-1, 9.45013788e-1, 9.42177336e-1,
  9.39274033e-1, 9.36304317e-1, 9.33268638e-1, 9.30167455e-1, 9.27001237e-1,
  9.23770461e-1, 9.20475618e-1, 9.17117204e-1, 9.13695728e-1, 9.10211707e-1,
  9.06665667e-1, 9.03058145e-1, 8.99389686e-1, 8.95660845e-1, 8.91872186e-1,
  8.88024281e-1, 8.84117711e-1, 8.80153069e-1, 8.76130952e-1, 8.7205197e-1,
  8.67916738e-1, 8.63725883e-1, 8.59480037e-1, 8.55179843e-1, 8.5082595e-1,
  8.46419017e-1, 8.41959711e-1, 8.37448705e-1, 8.32886681e-1, 8.28274329e-1,
  8.23612347e-1, 8.18901439e-1, 8.14142317e-1, 8.09335702e-1, 8.04482319e-1,
  7.99582902e-1, 7.94638193e-1, 7.89648938e-1, 7.84615893e-1, 7.79539817e-1,
  7.74421479e-1, 7.69261652e-1, 7.64061117e-1, 7.58820659e-1, 7.5354107e-1,
  7.4822315e-1, 7.42867702e-1, 7.37475536e-1, 7.32047467e-1, 7.26584315e-1,
  7.21086907e-1, 7.15556073e-1, 7.09992651e-1, 7.0439748e-1, 6.98771407e-1,
  6.93115283e-1, 6.87429962e-1, 6.81716305e-1, 6.75975174e-1, 6.70207439e-1,
  6.6441397e-1, 6.58595644e-1, 6.52753341e-1, 6.46887944e-1, 6.41000339e-1,
  6.35091417e-1, 6.2916207e-1, 6.23213197e-1, 6.17245695e-1, 6.11260467e-1,
  6.05258418e-1, 5.99240456e-1, 5.93207489e-1, 5.87160431e-1, 5.81100196e-1,
  5.75027699e-1, 5.68943859e-1, 5.62849596e-1, 5.56745831e-1, 5.50633486e-1,
  5.44513487e-1, 5.38386758e-1, 5.32254225e-1, 5.26116815e-1, 5.19975458e-1,
  5.1383108e-1, 5.07684611e-1, 5.0153698e-1, 4.95389117e-1, 4.89241951e-1,
  4.83096412e-1, 4.76953428e-1, 4.70813928e-1, 4.64678841e-1, 4.58549094e-1,
  4.52425614e-1, 4.46309327e-1, 4.40201156e-1, 4.34102027e-1, 4.2801286e-1,
  4.21934577e-1, 4.15868096e-1, 4.09814335e-1, 4.03774209e-1, 3.97748631e-1,
  3.91738511e-1, 3.8574476e-1, 3.79768282e-1, 3.73809982e-1, 3.6787076e-1,
  3.61951513e-1, 3.56053138e-1, 3.50176526e-1, 3.44322565e-1, 3.38492141e-1,
  3.32686134e-1, 3.26905422e-1, 3.21150881e-1, 3.15423378e-1, 3.09723782e-1,
  3.04052952e-1, 2.98411747e-1, 2.92801019e-1, 2.87221617e-1, 2.81674384e-1,
  2.76160159e-1, 2.70679775e-1, 2.65234062e-1, 2.59823842e-1, 2.54449933e-1,
  2.49113148e-1, 2.43814294e-1, 2.38554171e-1, 2.33333576e-1, 2.28153297e-1,
  2.23014117e-1, 2.17916814e-1, 2.12862158e-1, 2.07850913e-1, 2.02883837e-1,
  1.97961681e-1, 1.9308519e-1, 1.88255099e-1, 1.8347214e-1, 1.78737036e-1,
  1.74050502e-1, 1.69413247e-1, 1.64825973e-1, 1.60289372e-1, 1.55804131e-1,
  1.51370928e-1, 1.46990432e-1, 1.42663307e-1, 1.38390206e-1, 1.34171776e-1,
  1.30008654e-1, 1.25901469e-1, 1.21850843e-1, 1.17857388e-1, 1.13921708e-1,
  1.10044397e-1, 1.06226043e-1, 1.02467221e-1, 9.87685015e-2, 9.51304424e-2,
  9.1553594e-2, 8.80384971e-2, 8.45856832e-2, 8.11956742e-2, 7.78689827e-2,
  7.46061116e-2, 7.14075543e-2, 6.82737943e-2, 6.52053053e-2, 6.22025514e-2,
  5.92659864e-2, 5.63960544e-2, 5.35931893e-2, 5.08578147e-2, 4.81903443e-2,
  4.55911813e-2, 4.30607187e-2, 4.05993391e-2, 3.82074146e-2, 3.58853068e-2,
  3.36333667e-2, 3.1451935e-2, 2.93413412e-2, 2.73019047e-2, 2.53339336e-2,
  2.34377255e-2, 2.16135671e-2, 1.98617342e-2, 1.81824916e-2, 1.65760932e-2,
  1.50427819e-2, 1.35827895e-2, 1.21963367e-2, 1.08836332e-2, 9.64487731e-3,
  8.48025644e-3, 7.38994662e-3, 6.3741127e-3, 5.43290826e-3, 4.56647559e-3,
  3.77494569e-3, 3.05843822e-3, 2.41706151e-3, 1.85091253e-3, 1.36007687e-3,
  9.44628746e-4, 6.04630957e-4, 3.4013491e-4, 1.51180595e-4, 3.77965773e-5, 0.0,
];
import { FFT } from "dsp.js";
import { unmute } from "./unmute.min.js";
let globalAudioContext = null;
let globalGainNode = null;

// subscription for new hits
import { onCreateHit } from "./graphql/subscriptions";
let subscription;

import { extractFileInfo } from "@/utils";

window.gonative_app_resumed = function () {
  console.log("gonative_app_resumed");
  // window.location.reload();
};

export default {
  name: "App",
  props: ["user", "goHomeClicked", "toggleMapClicked", "toggleBadgeClicked"],
  watch: {
    goHomeClicked: function () {
      // watch it
      // console.log("Haikbuox.vue goHomeClicked:", this.haikuboxLoaded);
      // mounted gets run again when home clicked
      if (this.haikuboxLoaded == 1) this.getDevicesByOwner();
      this.showBadge = false;
      this.showMap = false;
    },
    toggleMapClicked: function () {
      this.showMap = !this.showMap;
      if (this.showMap === true) {
        this.showBadge = false;
        if (this.mapInitialized == false) {
          this.getDevices();
          this.mapInitialized = true;
        }
        // this.updateCurrentHaikuboxRadius(); // kick off animation
      }
      // console.log('showMap',this.showMap);
    },
    toggleBadgeClicked: function () {
      this.showBadge = !this.showBadge;
      if (this.showBadge) this.showMap = false;
      // console.log("showBadge", this.showBadge);
    },
  },
  mounted() {
    this.haikuboxLoaded = 0;
    // console.log("haikubox.vue mounted:", this.user);
    // delay is to handle page reload, waiting for user auth update
    const haikuboxLanguage = localStorage.getItem("haikuboxLanguage");
    if (haikuboxLanguage != null) {
      this.setLanguage(haikuboxLanguage);
    } else {
      let browserLanguage = navigator.language || navigator.languages[0];
      this.browserLang = browserLanguage.split("-")[0];
      // console.log("language", this.browserLang);
      this.setLanguage(this.browserLang);
    }
    // get view from local storage
    const haikuboxView = localStorage.getItem("haikuboxView");
    const haikuboxViewText = this.t(haikuboxView);
    // console.log('Mounted Haikubox View', haikuboxView, haikuboxViewText);
    if (haikuboxView != null) {
      const haikuboxViewIcon = localStorage.getItem("haikuboxViewIcon");
      this.navSelection = {
        id: haikuboxView,
        text: haikuboxViewText,
        icon: haikuboxViewIcon,
      };
    }

    // get confidence from local storage
    const haikuboxConfidence = localStorage.getItem("haikuboxConfidence");

    // console.log('Mounted Haikubox Confidence', haikuboxConfidence);
    if (haikuboxConfidence != null) {
      this.viewSettings= haikuboxConfidence;
      this.setViewConfidence(this.viewSettings); // set threshold values
    }

    if (this.user != "") this.getDevicesByOwner();
    else {
      setTimeout(this.getDevicesByOwner, 1000); // load owners boxes first
      // console.log('delay load');
    }
    // if (this.devicesByOwner[0] != null) {
    //   // this.clickDevice(this.devicesByOwner[0], 0, true, this.devicesByOwner[0].lat, this.devicesByOwner[0].lon);
    // }
    // else {
    // // this
    //   // console.log("mounted getDevices");
    //   // setTimeout(this.getDevices, 1000); // only load if no owner devices, or if click on map
    // }

    // check for oneSignalConsent if on smartphone app
    if (navigator.userAgent.indexOf("gonative") > -1) {
      this.goNativeActive = true;
      setTimeout(this.checkOneSignalConsent, 2000);
    }
    this.haikuboxLoaded = 1;

    // setTimeout(this.getDevicesByOwner, 500);
    // this.startAnimation();
  },
  components: {
    Plotly,
    LCircle,
    LTooltip,
  },
  data() {
    return {
      browserLang: "",
      currentTranslations: {},
      languages: [
        "da",
        "de",
        "en",
        "es",
        "fr",
        "fi",
        "it",
        "nl",
        "no",
        "pt",
        "sv",
      ],
      selectedLanguage: "en",
      haikuboxLoaded: 0,
      yesterdayNumSpecies: 0,
      yesterdayCallsAndSongs: 0,
      yesterdayMostFrequent: "",
      yesterdaySpCode: 0,
      navSelection: {
        id: "Last 2 Hours",
        text: "Last 2 Hours",
        icon: "mdi-clock-outline",
      },
      // haiku: {
      //   src: "https://haikubox-images.s3.amazonaws.com/carousel/haikuPoemBackground1.jpeg",
      //   type: "haiku",
      //   heading: "",
      //   poem1: "On a withered branch",
      //   poem2: "a crow is perched",
      //   poem3: "an autumn evening",
      //   poemAuthor: "Basho",
      //   poemLink:
      //     "https://www.basho4humanity.com/topic-description.php?ID=1525957618",
      //   poemLinkName: "Learn More",
      // },
      haiku: {
        src: "https://haikubox-images.s3.amazonaws.com/carousel/haikuPoemBackground7.jpeg",
        type: "haiku",
        heading: "",
        poem1: "At four o'clock the crows;",
        poem2: "at five o'clock the sparrows -",
        poem3: "the end of a summer night.",
        poemAuthor: "Shiki Masaoka",
        poemLink:
          "https://allpoetry.com/a-cuckoo-cries",
        poemLinkName: "Learn More",
      },
      moreActiveSpeciesList: [],
      csvDialog: false,
      csvDates: ["", ""],
      downloadSummary: true,
      downloadRaw: false,
      showMap: false,
      showBadge: false,
      playGettingStartedVideo: false,
      currentView: "Recent",
      lastUpdated: "",
      lastStatusUpdate: "",
      confidenceThreshold: 0.4,
      specSumThreshold: 2,
      viewSettings: "Medium",
      recentHours: 2,
      hitsLoading: 0,
      haikuboxSelect: {},
      bookmarkSelect: {},
      devicesByOwner: [],
      hidePics: false,
      isOwner: false,
      showRenewAlert: false,
      subscriptionActive: true,
      newBirdAlert: false,
      authState: undefined,
      goNativeActive: false,
      osConsentGranted: false,
      birdCastUrl: "https://dashboard.birdcast.info/",
      clipSeconds: 3,
      maxClipSeconds: 3,
      playbackGain: 100,
      fftLength: 512,
      halfLength: 256,
      lastEnhancedId: "",
      lastEnhancedAudio: [],
      isVisibilityListenerAdded: false,
      lat: 0.0,
      lon: 0.0,
      snackbar: false,
      hitCalendarDatePicked: true,
      hitDatePicker: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      maxDate: new Date().toISOString().substr(0, 10),
      minDate: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .substr(0, 10),
      fusionSchema: [
        {
          name: "Time",
          type: "date",
          format: "%Y-%m-%d %H:%M",
        },
        {
          name: "Detections",
          type: "number",
        },
      ],
      fusionSchemaDaily: [
        {
          name: "Date",
          type: "date",
          format: "%Y-%m-%d",
        },
        {
          name: "Detections",
          type: "number",
        },
      ],
      dataSource: {
        data: null,
        legend: {
          enabled: "0",
        },
        navigator: {
          enabled: 0,
        },
        caption: {
          text: "Detections",
        },
        subcaption: {
          text: "All Species",
        },
        extensions: {
          customRangeSelector: {
            enabled: "0",
          },
        },
        yAxis: [
          {
            plot: {
              value: "Detections",
              type: "column",
            },
            format: {
              prefix: "",
            },
            title: "Avg/15 minutes",
          },
        ],
      },
      plotlyLayoutHeatmap: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: true,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: true,
          fixedrange: true,
        },
        title: "Calls Per Hour",
        margin: {
          l: 60,
          r: 40,
          b: 60,
          t: 40,
          pad: 4,
        },
        height: 300,
        hovermode: false,
      },
      plotlyLayout: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        hovermode: false,
      },
      dropdownVersionList: [
        "1.38",
        "1.41",
        "2.03",
        "2.06",
        "2.07",
        "2.08",
        "2.09",
      ],
      dropdownVersion: "2.09",
      hiddenList: [
        "Gun",
        "Power tools",
        "",
        "Engine",
        "Siren",
        "Fireworks",
        "Environmental",
        "Human vocal",
        "Human whistle",
        "Human non-vocal",
        "Dog",
        "nocode",
        "soundscape",
        "Rock Pigeon",
        "Black Vulture",
        "Cattle Egret",
        "Black-crowned Night-Heron",
        "Noise",
        "Northern Cricket Frog",
        "Southern Cricket Frog",
        "Allard's Ground Cricket",
        "Tinkling Ground Cricket",
        "Walker's Ground Cricket",
        "Confused Ground Cricket",
        "Carolina Ground Cricket",
        "Clicker Round-winged Katydid",
        "Common Virtuoso Katydid",
        "Oblong-winged Katydid",
        "Rattler Round-winged Katydid",
        "Say's Trig",
        "American Toad",
        "Yosemite Toad",
        "Great Plains Toad",
        "Fowler's Toad",
        "Houston Toad",
        "Arizona Toad",
        "Oak Toad",
        "Texas Toad",
        "Southern Toad",
        "Woodhouse's Toad",
        "Honey Bee",
        "Protean Shieldback",
        "Coyote",
        "Gray Wolf",
        "Short-winged Meadow Katydid",
        "Slender Meadow Katydid",
        "Pine Barrens Treefrog",
        "Canyon Treefrog",
        "Bird-voiced Treefrog",
        "Cope's Gray Treefrog",
        "Green Treefrog",
        "Pine Woods Treefrog",
        "Barking Treefrog",
        "Squirrel Treefrog",
        "Gray Treefrog",
        "Greenhouse Frog",
        "Eastern Narrow-mouthed Toad",
        "Great Plains Narrow-mouthed Toad",
        "Gryllus assimilis",
        "Southern Wood Cricket",
        "Fall Field Cricket",
        "Southeastern Field Cricket",
        "Columbian Trig",
        "Gulf Coast Toad",
        "American Bullfrog",
        "Green Frog",
        "Pickerel Frog",
        "Wood Frog",
        "Greater Angle-wing",
        "Miogryllus saussurei",
        "False Robust Conehead",
        "Sword-bearing Conehead",
        "Round-tipped Conehead",
        "Robust Conehead",
        "Cuban Ground Cricket",
        "White-tailed Deer",
        "Fast-calling Tree Cricket",
        "Davis's Tree Cricket",
        "Snowy Tree Cricket",
        "Blackhorned Tree Cricket",
        "Narrow-winged Tree Cricket",
        "Pine Tree Cricket",
        "Four-spotted Tree Cricket",
        "Agile Meadow Katydid",
        "Stripe-faced Meadow Katydid",
        "Handsome Meadow Katydid",
        "Jumping Bush Cricket",
        "Brimley's Chorus Frog",
        "Spotted Chorus Frog",
        "Spring Peeper",
        "Upland Chorus Frog",
        "Southern Chorus Frog",
        "Little Grass Frog",
        "Ornate Chorus Frog",
        "Strecker's Chorus Frog",
        "Striped Chorus Frog",
        "Common True Katydid",
        "Couch's Spadefoot",
        "Eastern Gray Squirrel",
        "Red Squirrel",
        "Eastern Chipmunk",
        "Curve-tailed Bush Katydid",
        "Fork-tailed Bush Katydid",
        "Texas Bush Katydid",
        "Pacific Chorus Frog",
        "Handsome Trig",
        "Red-legged Partridge",
      ],
      backgroundLabelColor: "blue",
      // isFetchingBoxes: true,
      connectedDevices: [],
      disconnectedDevices: [],
      bookmarkedDevices: [],
      mapInitialized: false,
      haikuboxStatus: [],
      userNotices: [],
      liveHits: [],
      hits: [],
      allHits: [],
      dailyCounts: [],
      liveIntervalId: null,
      currentSiteName: "",
      currentHaikuboxBookmark: false,
      currentSerial: "",
      currentTimezone: "America/New_York",
      seriesHourly: [],
      seriesDaily: [],
      allSpeciesList: [],
      speciesSelected: "",
      scrolledToBottom: false,
      dailyDetectionsTotal: [],
      dailySpeciesTotal: [],
      newSpeciesList: [],
      missingSpeciesList: [],
      dailySummaryList: [],
      dailySummaryDate: "",
      species1HourCounts: null,
      specTickLabels: ["0", "1", "2", "3"],
      currentWiFi: -60,
      checkConnectionFailed: false,
      wifiUpdatedAt: "",
      audioLink: "",
      downloadLink: "",
      shareDialog: false,
      shareCommonName: "",
      shareAudioFile: "",
      copyLinkSnackbar: false,
      totalLabeled: 0,
      speciesLabeled: [],
      totalSpeciesLabeled: 0,
      labelStreak: 0,
      labelStreakRecord: 0,
      targetLabel: 10,
      targetLabelSpecies: 2,
      targetLabelStreak: 2,
      percentTargetLabeled: 0,
      percentTargetLabelSpecies: 0,
      percentTargetLabelStreak: 0,
      badgeLabelRewards: [
        10, 25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000,
        3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 20000, 30000, 40000,
        50000, 100000, 200000, 1000000, 10000000,
      ],
      badgeLabelSpeciesRewards: [
        2, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85,
        90, 95, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 250, 300,
        350, 400, 500, 600, 700, 800, 900, 1000, 2000, 3000, 4000, 5000, 10000,
      ],
      badgleLabelStreakRewards: [
        2, 3, 5, 7, 10, 12, 14, 16, 21, 28, 60, 90, 120, 150, 180, 210, 240,
        270, 300, 330, 360, 1000, 10000,
      ],
      badgeLabelLevel: 0,
      badgeLabelSpeciesLevel: 0,
      badgeLabelStreakLevel: 0,
      newLabelBadge: false,
      newLabelSpeciesBadge: false,
      newLabelStreakBadge: false,
      notifyBirdInfo: false,
      notifyBirdInfoSnackShown: false,
      gn_OneSignalUserId: null,
      gn_OneSignalPlatform: null,
      gn_OneSignalInfo: "",
      animationInterval: "",
      animationRunning: false,
      summaryColorMapIndex: 0,
      summaryHourIndex: 0,
      summaryHour: 0,
      summaryHourLabel: "",
      zoomSummary: 3,
      centerSummary: latLng(39, -94),
      urlSummary:
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}",
      // "https://server.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}",
      maxZoomSummary: 15,
      maxZoomHitMap: 7,
      attributionSummary:
        "Tiles &copy; Esri &mdash; Source: US National Park Service",
      zoom: 3,
      center: latLng(39, -94),
      url: "https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}",
      urlStates:
        "https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}",
      urlStatesSummary:
        "Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC",
      attribution:
        "Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC",
      urlOcean:
        "https://server.arcgisonline.com/ArcGIS/rest/services/Ocean_Basemap/MapServer/tile/{z}/{y}/{x}",
      urlOceanAttribution:
        "Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri",
      currentZoom: 3,
      currentCenter: latLng(39, -94),
      mapOptions: {
        zoomSnap: 0.5,
      },
      hitMapOptions: {
        zoomControl: false,
      },
      bounds: latLngBounds([
        [20, -120],
        [55, -70],
      ]),
      iconConnected: icon({
        iconUrl: "./apple-icon-57.png",
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      iconDisconnected: icon({
        iconUrl: "./signal_wifi_off-24px.svg",
        iconSize: [24, 24],
        iconAnchor: [16, 37],
      }),
      currentHaikuboxRadius: 50,
      haikuboxMarkerID: 0,
      formFields: [
        {
          type: "email",
          label: "Email Address",
          placeholder: "Enter your email address",
          required: true,
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Enter password (>7 characters)",
          required: true,
        },
      ],
    };
  },
  computed: {
    dropdown_class() {
      const text = this.t("dropdown");
      // console.log(text);
      return text;
    },
    navList() {
      if (this.subscriptionActive == false) {
        return [
          {
            id: "Last 2 Hours",
            text: this.t("Last 2 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 12 Hours",
            text: this.t("Last 12 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 24 Hours",
            text: this.t("Last 24 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Resubscribe",
            text: this.t("ResubscribeInfo"),
            icon: "mdi-meteor",
          },
        ];
      } else {
        return [
          {
            id: "Last 2 Hours",
            text: this.t("Last 2 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 12 Hours",
            text: this.t("Last 12 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 24 Hours",
            text: this.t("Last 24 Hours"),
            icon: "mdi-clock-outline",
          },
          {
            id: "Yesterday",
            text: this.t("Yesterday"),
            icon: "mdi-calendar-clock",
          },
          { id: "Live", text: this.t("Live"), icon: "mdi-meteor" },
          { id: "All", text: this.t("All"), icon: "mdi-ballot-outline" },
        ];
      }
    },
  },
  methods: {
    setLanguage(lang) {
      // console.log(lang);
      if (
        (lang != "da") &
        (lang != "de") &
        (lang != "en") &
        (lang != "es") &
        (lang != "fi") &
        (lang != "fr") &
        (lang != "it") &
        (lang != "nl") &
        (lang != "no") &
        (lang != "pt") &
        (lang != "sv")
      ) {
        lang = "en";
      }
      this.loadTranslations(lang).then((translations) => {
        this.currentTranslations = translations;
      });
      localStorage.setItem("haikuboxLanguage", lang);
      this.selectedLanguage = lang;
      if (this.currentSerial != "") this.clickRefresh(this.currentSerial); // reload page
    },
    loadTranslations(lang) {
      return fetch(`/I18N/${lang}.json`)
        .then((response) => response.json())
        .then((translations) => {
          return translations;
        });
    },
    t(key, cn) {
      return this.currentTranslations[key] || cn;
    },
    navigateTo(url) {
      if(this.goNativeActive){
        window.location.href = 'gonative://window/open?url=' + url + '&mode=appbrowser';
      }
      else{
        window.open(url, '_blank');
      } 
    },
    changeView() {
      // console.log("changeView", this.navSelection);
      this.logClick(this.navSelection.id, "", "");
      clearInterval(this.liveIntervalId);

      // if subscription not active only show last 2 hours
      if (this.subscriptionActive == false) {
        if (this.navSelection.id == "Resubscribe") {
          this.navSelection.id = "Last 2 Hours";
          this.navSelection.text = this.t(this.navSelection.id);
          this.navSelection.icon = "mdi-clock-outline";
          this.$router.push("/settings");
        }
      }

      localStorage.setItem("haikuboxView", this.navSelection.id);
      localStorage.setItem("haikuboxViewIcon", this.navSelection.icon);
      if (this.navSelection.id == "Last 2 Hours") {
        this.currentView = "Recent";
        this.changeRecentHours(2);
      }
      if (this.navSelection.id == "Last 12 Hours") {
        this.currentView = "Recent";
        this.changeRecentHours(12);
      }
      if (this.navSelection.id == "Last 24 Hours") {
        this.currentView = "Recent";
        this.changeRecentHours(24);
      }
      if (this.navSelection.id == "All") {
        this.getAll(this.currentSerial);
        this.currentView = "All";
        this.logClick("All", "", "");
      }
      // // if switching from calendar date to live, load last 2 hours
      // if ((this.navSelection.id == "Live") & (this.recentHours == 0)) {
      //   this.changeRecentHours(2);
      // }
      if (this.navSelection.id == "Live") {
        this.changeRecentHours(1); // only load past hour
        this.liveHits = []; // clear liveHits so don't see old ones
        this.subscribe(this.currentSerial);
        // this.clickRefresh(this.currentSerial);
        this.currentView = "Live";
        this.liveIntervalId = setInterval(() => {
          this.getHits(this.currentSerial);
        }, 30000);
        this.logClick("Live", "", "");

      }
      if (this.navSelection.id == "Yesterday") {
        this.currentView = "Yesterday";
        this.logClick("Yesterday", "", "");
      }
    },
    changeRecentHours(numHours) {
      this.hitCalendarDatePicked = true; // hide calendar
      this.logClick("changeRecentHours_" + numHours, "", "");
      this.recentHours = numHours;
      this.hits = [];
      this.hitsLoading = 0;
      this.getHits(this.currentSerial);
    },
    async checkUserInteractionTableExists() {
      const userInteractionData = await API.graphql({
        query: getUserInteraction,
        variables: { id: this.user },
      });
      let userData = userInteractionData.data.getUserInteraction;
      // console.log("check for user", userData);
      if (userData == null) {
        const id = this.user;
        const totalLabeled = 0;
        const speciesLabeled = [];
        const speciesLabeledCode = [];
        const totalSpeciesLabeled = 0;
        const labelStreak = 0;
        const labelStreakRecord = 0;
        // createdAt
        const labelCounterData = {
          id,
          totalLabeled,
          speciesLabeled,
          speciesLabeledCode,
          totalSpeciesLabeled,
          labelStreak,
          labelStreakRecord,
        };

        await API.graphql({
          query: createUserInteraction,
          variables: { input: labelCounterData },
        });
        // console.log("checkUserInteractionTableExists: Create user.");
      }
    },
    async loadUserInteractionData() {
      // getUserInteraction
      const userInteractionData = await API.graphql({
        query: getUserInteraction,
        variables: { id: this.user },
      });
      let userData = userInteractionData.data.getUserInteraction;

      // check if more than 1 day since last labeled (note we are not resetting this in the database, just in the display)
      const nowDate = moment().format("YYYY-MM-DD");
      let oldDate = moment(userData.dateLastLabeled);
      let newDate = moment(nowDate);
      let diffDays = newDate.diff(oldDate, "days");
      if (diffDays > 1) this.labelStreak = 0;
      else {
        this.labelStreak = userData.labelStreak;
      }

      this.totalLabeled = userData.totalLabeled;
      this.speciesLabeled = userData.speciesLabeled;
      this.totalSpeciesLabeled = userData.totalSpeciesLabeled;
      this.labelStreakRecord = userData.labelStreakRecord;
      this.updateLabelBadgeTargetLevels();
    },
    updateLabelBadgeTargetLevels() {
      // get target level for number of labels
      var nextLevelIndex = 0;
      for (let i = this.badgeLabelRewards.length - 1; i >= 0; i--) {
        if (this.totalLabeled >= this.badgeLabelRewards[i]) {
          nextLevelIndex = i + 1;
          break;
        }
      }
      if (nextLevelIndex > this.badgeLabelRewards.length - 1)
        nextLevelIndex = this.badgeLabelRewards.length - 1;
      this.targetLabel = this.badgeLabelRewards[nextLevelIndex];
      this.badgeLabelLevel = nextLevelIndex;

      // get target level for number of species
      var nextLevelIndexSpecies = 0;
      for (let i = this.badgeLabelSpeciesRewards.length - 1; i >= 0; i--) {
        if (this.totalSpeciesLabeled >= this.badgeLabelSpeciesRewards[i]) {
          nextLevelIndexSpecies = i + 1;
          break;
        }
      }
      if (nextLevelIndexSpecies > this.badgeLabelSpeciesRewards.length - 1)
        nextLevelIndexSpecies = this.badgeLabelSpeciesRewards.length - 1;
      this.targetLabelSpecies =
        this.badgeLabelSpeciesRewards[nextLevelIndexSpecies];
      this.badgeLabelSpeciesLevel = nextLevelIndexSpecies;

      // get target level for label streak
      var nextLevelIndexStreak = 0;
      for (let i = this.badgleLabelStreakRewards.length - 1; i >= 0; i--) {
        if (this.labelStreakRecord >= this.badgleLabelStreakRewards[i]) {
          nextLevelIndexStreak = i + 1;
          break;
        }
      }
      if (nextLevelIndexStreak > this.badgleLabelStreakRewards.length - 1)
        nextLevelIndexStreak = this.badgleLabelStreakRewards.length - 1;
      this.targetLabelStreak =
        this.badgleLabelStreakRewards[nextLevelIndexStreak];
      this.badgeLabelStreakLevel = nextLevelIndexStreak;

      this.percentTargetLabeled = (this.totalLabeled / this.targetLabel) * 100;
      this.percentTargetLabelSpecies =
        (this.totalSpeciesLabeled / this.targetLabelSpecies) * 100;
      this.percentTargetLabelStreak =
        (this.labelStreakRecord / this.targetLabelStreak) * 100;

      // console.log("badgeLabelStreakLevel", this.badgeLabelStreakLevel);
      // console.log("totalLabeled", this.totalLabeled);
      // console.log("totalSpeciesLabeled", this.totalSpeciesLabeled);
      // console.log("labelStreakRecord", this.labelStreakRecord);
      // console.log("targetLabel", this.targetLabel);
      // console.log("targetLabelSpecies", this.targetLabelSpecies);
      // console.log("targetLabelStreak", this.targetLabelStreak);
      // console.log("badgeLabelSpeciesLevel", this.badgeLabelSpeciesLevel);
      // console.log("percentTargetLabelSpecies", this.percentTargetLabelSpecies);
    },
    async labelHit(index, item) {
      // console.log("labelHit", index, item);
      if (!item.classLabel) return;
      this.logClick("label", item.spCode, item.cn);

      // copy file to label bucket
      await Storage.copy(
        { key: item.wav, level: "public" },
        { key: "label/" + item.wav, level: "private" }
      );

      if (item.classLabel == this.t("No, it's a ...")) {
        this.hits[index].showEntryBox = true;
        this.hits[index].showSubmitBox = true;
        this.hits[index].id += 1; // increment ID so that component updates
        // console.log();
        return;
      }

      const serial = item.serial;
      const dt = item.currentWav["dt"];
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.currentWav["filename"];
      const labeledBy = this.user;
      const label = item.classLabel;
      const score = item.currentWav["score"];
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });

      // console.log(labeledData);

      if (
        (item.classLabel == this.t("No")) |
        (item.classLabel == this.t("Yes"))
      ) {
        this.hits[index].showEntryBox = false;
        this.hits[index].id += 1; // increment ID so that component updates
      }

      // getUserInteraction
      const userInteractionData = await API.graphql({
        query: getUserInteraction,
        variables: { id: this.user },
      });
      let userData = userInteractionData.data.getUserInteraction;
      // console.log("userInteractionData", userData);

      const id = this.user;
      const totalLabeled = userData.totalLabeled + 1;

      // Check if species is a new one for this user
      if (!userData.speciesLabeledCode.includes(item.spCode)) {
        userData.speciesLabeled.push(item.cn);
        userData.speciesLabeledCode.push(item.spCode);
        userData.totalSpeciesLabeled += 1;
      }

      const speciesLabeled = userData.speciesLabeled;
      const speciesLabeledCode = userData.speciesLabeledCode;
      const totalSpeciesLabeled = userData.totalSpeciesLabeled;

      // Update Label Streak (# days in a row)
      const nowDate = moment().format("YYYY-MM-DD");
      if (userData.dateLastLabeled == null) {
        userData.dateLastLabeled = nowDate;
        userData.labelStreak = 1;
      }
      // new day?
      let oldDate = moment(userData.dateLastLabeled);
      let newDate = moment(nowDate);
      let diffDays = newDate.diff(oldDate, "days");

      if (diffDays == 1) {
        userData.labelStreak += 1; // increment if it has been at least one day but not more than 2
      } else if (diffDays > 1) {
        userData.labelStreak = 1; // reset if it has been
      }
      const labelStreak = userData.labelStreak;

      // update labelStreakRecord
      if (userData.labelStreak > userData.labelStreakRecord) {
        userData.labelStreakRecord = userData.labelStreak;
      }
      const labelStreakRecord = userData.labelStreakRecord;
      const dateLastLabeled = nowDate;

      const labelCounterData = {
        id,
        totalLabeled,
        speciesLabeled,
        speciesLabeledCode,
        totalSpeciesLabeled,
        labelStreak,
        labelStreakRecord,
        dateLastLabeled,
      };

      API.graphql({
        query: updateUserInteraction,
        variables: { input: labelCounterData },
      });
      // console.log("updateUserInteraction", labelCounterData);

      this.totalLabeled = totalLabeled;
      this.speciesLabeled = speciesLabeled;
      this.totalSpeciesLabeled = totalSpeciesLabeled;
      this.labelStreak = labelStreak;
      this.labelStreakRecord = labelStreakRecord;

      // check if hit any badge levels
      if (this.totalLabeled == this.targetLabel) {
        // new label badge!
        this.newLabelBadge = true;
        // ("new label badge");
      }
      if (this.totalSpeciesLabeled == this.targetLabelSpecies) {
        // new species badge!
        this.newLabelSpeciesBadge = true;
        // console.log("new species label badge");
      }
      if (this.labelStreakRecord == this.targetLabelStreak) {
        // new streak badge!
        this.newLabelStreakBadge = true;
        // console.log("new label streak badge");
      }

      this.updateLabelBadgeTargetLevels();
    },
    labelHitCustom(index, item) {
      // console.log("labelHitCustom");
      if (!item.classLabel) return;
      const serial = item.serial;
      const dt = item.dt;
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.wav;
      const labeledBy = this.user;
      const label = item.tellUsMore;
      const score = item.score;
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });
      this.hits[index].submitted = true;
      this.hits[index].showSubmitBox = false;
      this.hits[index].id += 1; // increment ID so that component updates
    },
    async download(item) {
      // console.log(item);
      let audioFile = item.currentWav["filename"];
      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;
      if (audioFile[5] == "P" | audioFile[0] == "p") {
          globalGainNode.gain.value = globalGainNode.gain.value / 20;
      }

      var audioUrl = await Storage.get(audioFile);
      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);
      let signal = audioBuffer.getChannelData(0);
      const max =
        1.5 * signal.reduce((acc, val) => Math.max(acc, val), -Infinity);
      const normalizedSignal = signal.map((value) => value / max);
      // console.log(audioBuffer);

      function saveArrayToWavFile(array, sampleRate, filename) {
        const numChannels = 1;
        const bitsPerSample = 16;
        const byteRate = (sampleRate * numChannels * bitsPerSample) / 8;
        const blockAlign = (numChannels * bitsPerSample) / 8;
        const dataSize = (array.length * bitsPerSample) / 8;
        const fileLength = 44 + dataSize;

        // Create a buffer for the WAV file
        const buffer = new ArrayBuffer(fileLength);
        const view = new DataView(buffer);

        // Write the WAV file header
        writeString(view, 0, "RIFF");
        view.setUint32(4, fileLength - 8, true);
        writeString(view, 8, "WAVE");
        writeString(view, 12, "fmt ");
        view.setUint32(16, 16, true);
        view.setUint16(20, 1, true);
        view.setUint16(22, numChannels, true);
        view.setUint32(24, sampleRate, true);
        view.setUint32(28, byteRate, true);
        view.setUint16(32, blockAlign, true);
        view.setUint16(34, bitsPerSample, true);
        writeString(view, 36, "data");
        view.setUint32(40, dataSize, true);

        // Write the sample data
        for (let i = 0; i < array.length; i++) {
          view.setInt16(44 + i * 2, array[i] * 32767, true);
        }

        // Convert the buffer to a Blob
        const blob = new Blob([buffer], { type: "audio/wav" });

        // Create a link element and trigger a download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      function writeString(view, offset, string) {
        for (let i = 0; i < string.length; i++) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }
      let filename =
        this.replaceSpaces(item.cn) +
        "_" +
        this.replaceSpaces(item.currentWav["listname"]) +
        ".wav";
      saveArrayToWavFile(normalizedSignal, audioBuffer.sampleRate, filename);
    },
    replaceSpaces(itemWithSpaces) {
      const itemWithUnderscores = itemWithSpaces.replace(/ /g, "_");
      const itemWithApostrophe = itemWithUnderscores.replace(/'/g, "");
      const itemWithColon = itemWithApostrophe.replace(/:/g, "");
      const itemWithComma = itemWithColon.replace(/,/g, "");
      // console.log("link", itemWithColon);
      return itemWithComma;
    },
    showBirdCastButton() {
      // Check dates
      const currentDate = new Date();
      const year = currentDate.getFullYear();

      // Define the start and end dates for the first range
      const startRange1 = new Date(year, 2, 1); // March 1st (month is 0-indexed)
      const endRange1 = new Date(year, 5, 15); // June 15th (month is 0-indexed)

      // Define the start and end dates for the second range
      const startRange2 = new Date(year, 7, 1); // August 1st (month is 0-indexed)
      const endRange2 = new Date(year, 10, 9); // November 9th (month is 0-indexed)

      // Check if current date is between start and end dates of either range
      let showButton =
        (currentDate >= startRange1 && currentDate <= endRange1) ||
        (currentDate >= startRange2 && currentDate <= endRange2);
      if (this.lon > -30) showButton = false;
      return showButton;
    },
    async getBirdcastUrl() {
      if (this.showBirdCastButton()==false) return;
      // get county location with fips lookup
      var fipsCode = "https://dashboard.birdcast.info";
      const url =
        "https://geo.fcc.gov/api/census/area?lat=" +
        this.lat +
        "&lon=" +
        this.lon +
        "&censusYear=2020&format=json";
      // console.log("getBirdcastUrl", url);
      var countyFips, countyCode, stateCode;

      await fetch(url)
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          try {
            countyFips = res.results[0].county_fips;
            stateCode = res.results[0].state_code;
            countyCode = countyFips.slice(2);
          } catch (err) {
            // console.log(res);
          }
        });
      // console.log('fipsCode', fipsCode);
      if ((countyFips != null) & (countyFips != "")) {
        fipsCode =
          "https://dashboard.birdcast.info/region/US-" +
          stateCode +
          "-" +
          countyCode;
      }
      this.birdCastUrl = fipsCode;
    },
    // async loadAndPlay(stationID, commonName) {
    //   // get wav file
    //   // query MyQuery($cnDt: ModelhitHitsBySpeciesByDateCompositeKeyConditionInput = {gt: {cn: "Northern Cardinal", dt:"2021-03-20T20:27:03.968487Z"}}) {
    //   //     hitsBySpeciesByDate(serial: "Haikubox_100000009aec770c", cnDt: $cnDt) {
    //   //       items {
    //   //         wav
    //   //         score
    //   //       }
    //   //     }
    //   //   }

    //   let lastMonthDate = moment.utc().subtract(60, "days").format();

    //   // could not figure out how to limit return to wav and score
    //   const wavFilterArg = {
    //     serial: stationID,
    //     cnDt: { gt: { cn: commonName, dt: lastMonthDate } },
    //     limit: 20,
    //     filter: { score: { gt: this.confidenceThreshold } },
    //   };
    //   const wavFilenames = await API.graphql({
    //     query: hitsBySpeciesByDate,
    //     variables: wavFilterArg,
    //   });
    //   var retWavs = wavFilenames.data.hitsBySpeciesByDate.items;
    //   console.log(retWavs);
    // },
    initAudioContext() {
      if (!globalAudioContext) {
        const isIOS = /iPhone|iPod|iPad/.test(navigator.userAgent);
        if (isIOS) {
          globalAudioContext = new AudioContext();
          // Note: audioContext, allowBackgroundPlayback, forceIOSBehavior
          unmute(globalAudioContext, false, false);
        } else {
          globalAudioContext = new AudioContext();
        }
        globalGainNode = globalAudioContext.createGain();
        globalGainNode.gain.value = this.playbackGain; // Set initial volume level
        globalGainNode.connect(globalAudioContext.destination);

        if (isIOS && !this.isVisibilityListenerAdded) {
          document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            if (globalAudioContext.state !== "suspended") {
              globalAudioContext.suspend();
              console.log("AudioContext suspended");
            }
          } else {
            if (globalAudioContext.state === "suspended") {
              globalAudioContext.resume().then(() => {
                console.log("AudioContext resumed");
                
                globalAudioContext.close().then(() => {
                  console.log("AudioContext closed");
                  globalAudioContext = new AudioContext();
                  globalGainNode = globalAudioContext.createGain();
                  globalGainNode.gain.value = this.playbackGain; // Set initial volume level
                  globalGainNode.connect(globalAudioContext.destination); 
                  unmute(globalAudioContext, false, false);
                }).catch((error) => {
                  console.error("Error closing AudioContext:", error);
                });
              }).catch((error) => {
                console.error("Error resuming AudioContext:", error);
              });
            }
          }
        });
        // Set the flag to true after adding the listener
        this.isVisibilityListenerAdded = true;
      }
      }
    },
    async playFile(audioFile, spCode, cn, item, index, resetLabel) {
      // this.logClick("playFile", spCode, cn);
      // console.log(item);
      // console.log("playFile", resetLabel);
      // reset label is true when playing from wav select dropdown
      if (resetLabel === true) {
        item.classLabel = null;
        // get favorite status for this file

        const favoriteHit = await API.graphql({
          query: getFavoriteHit,
          variables: {
            id: audioFile,
          },
        });

        if (favoriteHit.data.getFavoriteHit != null) {
          item.favoriteHit = true;
        } else {
          item.favoriteHit = false;
        }
        item.wav = audioFile;
      }
      // console.log("playFile", audioFile);

      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;
      if (audioFile[5] == "P" | audioFile[0] == "p") {
          globalGainNode.gain.value = globalGainNode.gain.value / 20;
      }
      
      var audioUrl = await Storage.get(audioFile);
      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);

      const sampleSource = globalAudioContext.createBufferSource();
      sampleSource.buffer = audioBuffer;
      sampleSource.connect(globalGainNode);
      
      if (audioFile[5] == "P" | audioFile[0] == "p") {
        const {fileUnixTime, sampleRate, duration} = extractFileInfo(audioFile);
        var isoTimeSeconds = Math.floor(Date.parse(item.dt) / 1000);
        var diffSeconds = isoTimeSeconds - fileUnixTime;
        // Define the start and end times (in seconds)
        var startTime = diffSeconds; // Start at diffseconds second
        if (startTime < 0) startTime = 0;
        if (startTime > (12 - this.clipSeconds)) startTime = 12 - this.clipSeconds;
        sampleSource.start(0, startTime, this.clipSeconds); //play x seconds
      }else{
        sampleSource.start(0);
      }

      if (this.currentView == "Recent") {
        if (item.window == "spectrogram") {
          this.spectrogram(index, item.currentWav["filename"], "Recent");
          item.classLabel = null;
        }
      }
    },
    async playFileEnhance(audioFile, spCode, cn, id, item) {
      this.logClick("playFileEnhance", spCode, cn);

      this.initAudioContext();
      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      // playing last file again
      if (this.lastEnhancedId == id) {
        // Create an AudioBufferSourceNode
        const sourceNode = globalAudioContext.createBufferSource();
        sourceNode.buffer = this.lastEnhancedAudio;
        // Connect the source node to the AudioContext's destination (speakers)
        sourceNode.connect(globalAudioContext.destination);
        // Start playback
        sourceNode.start();
        return;
      }

      async function getFile(filepath) {
        const response = await fetch(filepath);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await decodeAudioData(
          globalAudioContext,
          arrayBuffer
        );
        return audioBuffer;
      }

      async function setupSample(filePath) {
        // var context = new AudioContext();
        const sample = await getFile(filePath);
        return sample;
      }

      Storage.get(audioFile).then((result) => {
        // console.log("Storage get", result);
        setupSample(result).then((sample) => {
          

          let origSignal = sample.getChannelData(0);
          var signal;

          // Define the start and end times (in seconds)
          if (audioFile[5] == "P" | audioFile[0] == "p") {
            const {fileUnixTime, sampleRate, duration} = extractFileInfo(audioFile);
            // console.log('pfe', item);
            var isoTimeSeconds = Math.floor(Date.parse(item.dt) / 1000);
            var diffSeconds = isoTimeSeconds - fileUnixTime;
            // Define the start and end times (in seconds)
            var startTime = diffSeconds; // Start at diffseconds second
            if (startTime < 0) startTime = 0;
            if (startTime > (duration - this.clipSeconds)) startTime = duration - this.clipSeconds;

              // Convert time to sample indices
              var startSample = Math.floor(startTime * sample.sampleRate);
              var endSample = Math.floor(startSample + (this.clipSeconds * sample.sampleRate));

              // check if playback beyond end of clip
              if(endSample > sample.length) {
                endSample = sample.length - 1;
                startSample = endSample - (this.clipSeconds * sample.sampleRate);
                if (startSample < 0) startSample = 0;
              }
              
              // console.log("start", startSample);
              // console.log("end", endSample);

              signal = origSignal.slice(startSample, endSample);
            }
            else{
              signal = origSignal;
            }

          // Define STFT parameters
          const fftSize = 512;
          const overlap = 256;
          const hopSize = fftSize - overlap;
          // Compute the STFT
          const stft = [];
          var meanMag = new Array(fftSize).fill(0);
          var stdMag = new Array(fftSize).fill(0);
          var numStrides = 0;
          for (let i = 0; i < signal.length - fftSize; i += hopSize) {
            const frame = signal.slice(i, i + fftSize);
            // Hanning Window
            for (var k = 0; k < fftSize; k++) {
              frame[k] = frame[k] * hann[k];
            }
            var phasors = fft(frame);
            // console.log(phasors);
            // store running sum of magnitude to calculate mean
            for (var j = 0; j < phasors.length; j++) {
              meanMag[j] += Math.sqrt(
                phasors[j][0] * phasors[j][0] + phasors[j][1] * phasors[j][1]
              );
            }
            numStrides++;
            stft.push([...phasors]);
          }
          // console.log('stft', stft);
          for (let j = 0; j < fftSize; j++) {
            meanMag[j] = meanMag[j] / numStrides;
          }
          // calculate SD
          // loop through each time slice
          for (let i = 0; i < stft.length; i++) {
            // loop through each frequency
            for (let j = 0; j < fftSize; j++) {
              let magnitude =
                Math.sqrt(
                  stft[i][j][0] * stft[i][j][0] + stft[i][j][1] * stft[i][j][1]
                ) - meanMag[j];
              stdMag[j] += magnitude * magnitude;
            }
          }
          for (j = 0; j < fftSize; j++) {
            stdMag[j] = Math.sqrt(stdMag[j] / numStrides);
          }
          // gate values based on mean + 2*SD
          async function gateSpectrogram() {
            for (let i = 0; i < stft.length - 4; i++) {
              // loop through each frequency
              for (let j = 0; j < fftSize; j++) {
                // get average magnitude over 5 time slices
                let magnitude =
                  (Math.sqrt(
                    stft[i][j][0] * stft[i][j][0] +
                      stft[i][j][1] * stft[i][j][1]
                  ) +
                    Math.sqrt(
                      stft[i + 1][j][0] * stft[i + 1][j][0] +
                        stft[i + 1][j][1] * stft[i + 1][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 2][j][0] * stft[i + 2][j][0] +
                        stft[i + 2][j][1] * stft[i + 2][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 3][j][0] * stft[i + 3][j][0] +
                        stft[i + 3][j][1] * stft[i + 3][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 4][j][0] * stft[i + 4][j][0] +
                        stft[i + 4][j][1] * stft[i + 4][j][1]
                    )) /
                  5;
                if (magnitude < meanMag[j] + 1.9 * stdMag[j]) {
                  stft[i][j][0] = stft[i][j][0] * 0.2;
                  stft[i][j][1] = stft[i][j][1] * 0.2;
                  // also flip mirror
                  stft[i][fftSize - 1 - j][0] =
                    stft[i][fftSize - 1 - j][0] * 0.2;
                  stft[i][fftSize - 1 - j][1] =
                    stft[i][fftSize - 1 - j][1] * 0.2;
                  // console.log(i, j);
                }
                if (j < 4) {
                  stft[i][j][0] = stft[i][j][0] * 0.2;
                  stft[i][j][1] = stft[i][j][1] * 0.2;
                  // also flip mirror
                  stft[i][fftSize - 1 - j][0] =
                    stft[i][fftSize - 1 - j][0] * 0.2;
                  stft[i][fftSize - 1 - j][1] =
                    stft[i][fftSize - 1 - j][1] * 0.2;
                  // console.log(i, j);
                }
              }
            }
            return stft;
          }
          // Compute the ISTFT
          async function istft() {
            let recoveredSignal = new Array(signal.length).fill(0);
            let recoveredSignalComplex = new Array(fftSize);
            for (let i = 0; i < stft.length - 4; i++) {
              // console.log('before ifft', stft[i]);
              recoveredSignalComplex = ifft(stft[i]);
              // console.log('recoveredSignalComplex', recoveredSignalComplex);
              for (let j = 0; j < fftSize; j++) {
                if (i * overlap + j < signal.length) {
                  // get real part
                  recoveredSignal[i * hopSize + j] +=
                    recoveredSignalComplex[j][0];
                }
              }
            }
            return recoveredSignal;
          }
          gateSpectrogram()
            .then((res) => {
              // console.log(res);
              return istft();
            })
            .then((recoveredSignal) => {
              // console.log('recoveredSignal', recoveredSignal);
              var maxSignal = 0;
              for (let i = 0; i < recoveredSignal.length - 1000; i += 1000) {
                // get stack issues so doing in chunks
                var tempMax = Math.max(...recoveredSignal.slice(i, i + 1000));
                if (tempMax > maxSignal) {
                  maxSignal = tempMax;
                }
              }
              var maxSignal = 0.9 / maxSignal; // scale so can multiply to get max amp of 0.9
              // console.log('maxValue', maxSignal);
              // Create an AudioBuffer from the audio data
              const audioBuffer = globalAudioContext.createBuffer(
                1,
                recoveredSignal.length,
                sample.sampleRate
              );
              const channelData = audioBuffer.getChannelData(0);
              for (let i = 0; i < recoveredSignal.length; i++) {
                channelData[i] = recoveredSignal[i] * maxSignal;
              }
              // Create an AudioBufferSourceNode
              const sourceNode = globalAudioContext.createBufferSource();
              sourceNode.buffer = audioBuffer;
              // Connect the source node to the AudioContext's destination (speakers)
              sourceNode.connect(globalAudioContext.destination);
              // Start playback
              sourceNode.start();
              this.lastEnhancedId = id;
              this.lastEnhancedAudio = audioBuffer;
            });
        });
      });
    },
    zoomUpdate(zoom) {
      // console.log('zoomUpdate');
      this.currentZoom = Math.floor(zoom);
      this.updateCurrentHaikuboxRadius();
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    getEventText(item) {
      let momentText = moment(item.dt).locale(this.selectedLanguage).fromNow();
      if (momentText == "in a few seconds") {
        momentText = "just now";
      }
      if (momentText == "a few seconds ago") {
        momentText = "just now";
      }
      return momentText;
    },
    // getScoreText(score) {
    //   //let scoreText = score;
    //   let scoreText = "high";
    //   if (score < 0.4) {
    //     scoreText = "low";
    //   } else {
    //     if (score < 0.9) scoreText = "medium";
    //   }
    //   return scoreText;
    // },
    clickRefresh(currentSerial) {
      this.logClick("clickRefresh", "", "");
      this.getHits(currentSerial);
      this.getState(currentSerial); // current state including timezone
      if (this.isOwner) this.getStatus(currentSerial); // wifi strength
      // this.getHourlyCount(currentSerial);
      // this.loadSummary(currentSerial);
    },
    async ownerSelectDevice() {
      // need to get lat lon
      // console.log('ownerSelectDevice', this.haikuboxSelect);
      this.currentSerial = this.haikuboxSelect.serial;
      this.subscriptionActive = this.haikuboxSelect.subscriptionActive;

      // get new bird alert setting
      const id = this.currentSerial.split("_");
      const devicesInfo = await API.graphql({
        query: getDevice,
        variables: { id: id[1] },
      });
      var temp = devicesInfo.data.getDevice;
      this.newBirdAlert = temp.newBirdAlert;

      this.clickDevice(
        { serial: this.currentSerial, name: this.haikuboxSelect.name },
        true,
        true,
        this.haikuboxSelect.lat,
        this.haikuboxSelect.lon
      );
      this.bookmarkSelect = {};
      this.getBirdcastUrl();
      // try {
      //   this.getBirdcastUrl();
      // } catch (error) {
      //   console.error(error);
      // }
    },
    bookmarkSelectDevice() {
      // need to get lat lon
      // console.log("bookmarkSelectDevice", this.bookmarkSelect);
      this.currentSerial = this.bookmarkSelect.id;
      this.clickDevice(
        { serial: this.currentSerial, name: this.bookmarkSelect.name },
        true,
        false,
        this.bookmarkSelect.shareLat,
        this.bookmarkSelect.shareLon
      );
      this.haikuboxSelect = {};
    },
    async clickDevice(item, logClick, isOwner, lat, lon) {
      // console.log("clickDevice", item);
      // double-checking in case click on their own device from map
      if (isOwner == false) {
        for (let i = 0; i < this.devicesByOwner.length; i++) {
          if (this.devicesByOwner[i].serial.includes(item.serial))
            isOwner = true;
          this.isOwner = true;
        }
      }
      this.lat = lat;
      this.lon = lon;
      this.hitCalendarDatePicked = true; // this hides calendar if it is open
      this.hitDatePicker = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10); // reset to now
      if (this.recentHours == 0) this.recentHours = 2; // in case clicked on a device after clicking on Home calendar
      this.currentSiteName = item.name;
      if (logClick) this.logClick("clickDevice", "", "");
      this.isOwner = isOwner;
      this.checkUserInteractionTableExists();
      this.currentSerial = item.serial;
      this.liveHits = [];
      this.moreActiveSpeciesList = [];
      this.hits = []; //clear previously clicked site
      await this.getState(item.serial);
      this.getYesterdayCounts(item.serial);
      this.getHits(item.serial);
      this.changeView(); // this will set subscription for Live and load All if on All view
      // this.getPrivacy(item.serial);

      if (this.isOwner) {
        this.getStatus(item.serial);
        // console.log('clickDevice is owner', item);
        // if (item.newBirdAlert === null) item.newBirdAlert = false;
        // this.newBirdAlert = item.newBirdAlert;
      }
      if (this.isOwner == false) {
        // check if site is bookmarked
        let bookmarkID = this.currentSerial + "_" + this.user;
        const bmrk = await API.graphql({
          query: getBookmarkHaikubox,
          variables: { id: bookmarkID },
        });
        let retBookmark = bmrk.data.getBookmarkHaikubox;
        // console.log("clickDevice bookmark", retBookmark);
        if (retBookmark != null) this.currentHaikuboxBookmark = true;
        else {
          this.currentHaikuboxBookmark = false;
          this.bookmarkSelect = {}; // clear bookmark select dropdown
        }
        this.haikuboxSelect = {}; // clear Haikubox select dropdown
        this.getBirdcastUrl();
      }
      // this.loadSummary(item.serial);
      this.loadUserInteractionData();
      // this.getHourlyCount(item.serial);

      this.showMap = false;
      this.updateBounds();
    },
    async getState(serialClicked) {
      const deviceState = await API.graphql({
        query: getDeviceState,
        variables: { id: serialClicked },
      });
      var clickedDevice = deviceState.data.getDeviceState;
      // console.log("getState", clickedDevice);
      if (clickedDevice.timezone != null) {
        this.currentTimezone = clickedDevice.timezone;
      }
    },
    async updateBounds() {
      this.bounds = latLngBounds([
        [this.lat - 5.0, this.lon - 5.0],
        [this.lat + 5.0, this.lon + 5.0],
      ]);
    },
    async checkOneSignalConsent() {
      // console.log('checkOneSignalConsent');
      const oneSignalConsent = await API.graphql({
        query: getOneSignalConsent,
        variables: { id: this.user },
      });
      let consentData = oneSignalConsent.data.getOneSignalConsent;
      // console.log("checkOneSignalConsent", consentData);
      if (consentData.osConsentGranted == null) {
        this.osConsentGranted = false;
      } else {
        this.osConsentGranted = true;
      }
      //console.log('osConsentGranted', this.osConsentGranted);

      if (this.osConsentGranted) {
        this.grantOneSignalPrivacyConsent(); // this will connect oneSignal if new device and get OneSignal Info
      }
    },
    async grantOneSignalPrivacyConsent() {
      if (navigator.userAgent.indexOf("gonative") > -1) {
        await gonative.onesignal.userPrivacyConsent.grant();
        await gonative.onesignal.register();
        this.osConsentGranted = true;
        this.addConsentToOneSignalDb();
        this.getOneSignal();
      }
      this.notifyBirdInfo = false; // hide snackbar
    },
    async addConsentToOneSignalDb() {
      // update database
      const varArg = {
        id: this.user,
        osConsentGranted: true,
      };
      await API.graphql({
        query: createOneSignalConsent,
        variables: { input: varArg },
      });
    },
    async getOneSignal() {
      if (navigator.userAgent.indexOf("gonative") > -1) {
        this.gn_OneSignalInfo =
          "goNative active: " + this.devicesByOwner.length;
        let oneSignalInfo = await gonative.onesignal.onesignalInfo();
        this.gn_OneSignalUserId = oneSignalInfo.oneSignalUserId;
        this.gn_OneSignalPlatform = oneSignalInfo.platform;
        if (this.gn_OneSignalUserId) {
          for (let i = 0; i < this.devicesByOwner.length; i++) {
            const oneSignalData = {
              id: this.gn_OneSignalUserId + "_" + this.devicesByOwner[i].serial,
              playerID: this.gn_OneSignalUserId,
              platform: this.gn_OneSignalPlatform,
              serial: this.devicesByOwner[i].serial,
            };
            await API.graphql({
              query: createOneSignal,
              variables: { input: oneSignalData },
            });
          }
        }
      } else this.gn_OneSignalInfo = "Go Native Not Recoginized";
    },
    async getDevicesByOwner() {
      this.haikuboxLoaded = 0;
      var userID = this.user;
      if (userID == "" || userID == undefined) {
        this.showMap = true;
        await this.loadBookmarkedHaikuboxes();
        return;
      }
      // console.log("getDevicesByOwner", this.user);
      const devicesByOwner = await API.graphql({
        query: haikuboxByOwner,
        variables: { owner: userID },
      });
      this.devicesByOwner = devicesByOwner.data.haikuboxByOwner.items;

      // console.log("devicesByOwner", this.devicesByOwner);
      if (this.devicesByOwner.length > 0) {
        this.haikuboxSelect = this.devicesByOwner[0];
        this.haikuboxSelect.lat = this.devicesByOwner[0].lat;
        this.haikuboxSelect.lon = this.devicesByOwner[0].lon;
        // check if subscription still valid
        this.getSubscriptionState().then((value) => {
          // console.log('sub ok');
          this.ownerSelectDevice(); // this calls clickDevice after getting newBirdAlert
        });
       
        this.getOneSignal();
        this.getNotices(); // see if there are any notices to show
        await this.loadBookmarkedHaikuboxes();
      } else {
        // If there are no haikuboxes owned but one or more bookmarked go to first in list
        // console.log(
        //   "getDevicesByOwner check bookmarks",
        //   this.bookmarkedDevices
        // );
        await this.loadBookmarkedHaikuboxes();
        if (this.bookmarkedDevices.length > 0) {
          this.clickDevice(
            this.bookmarkedDevices[0],
            0,
            0,
            this.bookmarkedDevices[0].shareLat,
            this.bookmarkedDevices[0].shareLon
          );
        } else {
          // this.showMap = true;
          if (
            (this.user == "60c05843-732f-4d66-a49a-bd39658cdacb") |
            (this.user == "332232a5-51da-4f3e-a260-d83fdd959b12")
          ) {
            var demoHaikubox = {
              name: "Younger Lagoon 1",
              serial: "Haikubox_100000003071d681",
              lat: 36.956374713079256,
              lon: -122.06877083821281,
            };
            this.carouselItems[0].src =
              "https://haikubox-images.s3.amazonaws.com/carousel/YL_marinesteps.jpg";
          } else {
            var demoHaikubox = {
              name: "Haikubox Demo",
              serial: "Haikubox_3485188E66CC",
              lat: 41.601,
              lon: -70.608,
            };
          }

          this.clickDevice(
            demoHaikubox,
            0,
            false,
            demoHaikubox.lat,
            demoHaikubox.lon
          );
        }
      }
      this.haikuboxLoaded = 1;
      
      const userSettings = await API.graphql({
          query: getUserSettings,
          variables: { id: this.user },
        });
        // no entry yet leave at false
        if(userSettings.data.getUserSettings==null){
          this.hidePics = false;
        }
        else{
          this.hidePics = userSettings.data.getUserSettings.hidePics;
        }
    },
    async getSubscriptionState() {
      // query subscription state
      this.showRenewAlert = false;
      for (let i = 0; i < this.devicesByOwner.length; i++) {
        const subState = await API.graphql({
          query: getSubscription,
          variables: { id: this.devicesByOwner[i].serial },
        });
        // console.log(subState);
        let currentUnixTime = Math.floor(Date.now() / 1000); // convert ms to s
        if (subState?.data?.getSubscription?.prepaidPeriodEndUnix != null) {
          this.devicesByOwner[i].prepaidPeriodEndUnix = moment
            .unix(Number(subState.data.getSubscription.prepaidPeriodEndUnix))
            .format("LL");
          this.devicesByOwner[i].subscriptionActive = true;
        }

        if (subState?.data?.getSubscription?.stripeCurrentPeriodEndUnix != null) {
          this.devicesByOwner[i].stripeCurrentPeriodEndUnix = moment
            .unix(
              Number(subState.data.getSubscription.stripeCurrentPeriodEndUnix)
            )
            .format("LL");
          // check if stripeCurrentPeriodEndUnix is within 2 weeks (1209600 s) of expiring
          let stripeUnix = Number(
            subState.data.getSubscription.stripeCurrentPeriodEndUnix
          );
          // if((stripeUnix - currentUnixTime) < 1209600){
          //   this.showRenewAlert = true;
          // }
          if (stripeUnix - currentUnixTime < 0) {
            this.devicesByOwner[i].subscriptionActive = false;
          }
        } else {
          // Prepaid period
          if (subState?.data?.getSubscription?.prepaidPeriodEndUnix != null) {
            // check if prepaid period is within 2 weeks of expiring
            let stripeUnix = Number(
              subState.data.getSubscription.prepaidPeriodEndUnix
            );
            if (stripeUnix - currentUnixTime < 1209600) {
              this.showRenewAlert = true;
            }
            if (stripeUnix - currentUnixTime < 0) {
              this.devicesByOwner[i].subscriptionActive = false;
            }
          }
          else{
            console.log(this.devicesByOwner[i].id, "missing prepaidPeriodEndUnix");
            this.devicesByOwner[i].subscriptionActive = false;
          }
        }
      }
      return true;
    },
    async loadBookmarkedHaikuboxes() {
      var nextToken = null;
      var allDevices = [];
      do {
        const bookmarks = await API.graphql({
          query: bookmarkHaikuboxByOwner,
          variables: { owner: this.user, nextToken: nextToken },
        });
        allDevices = allDevices.concat(
          bookmarks.data.bookmarkHaikuboxByOwner.items
        );
        nextToken = bookmarks.data.bookmarkHaikuboxByOwner.nextToken;
      } while (nextToken != null);
      // console.log("loadBookmarkedHaikuboxes", allDevices);

      // are these Haikuboxes in shareMap
      var bookmarkedHaikuboxes = [];
      if (allDevices.length > 0) {
        for (let i = 0; i < allDevices.length; i++) {
          let id = allDevices[i].serial;
          const hbox = await API.graphql({
            query: getShareMap,
            variables: { id: id },
          });
          let retShare = hbox.data.getShareMap;
          // console.log("load bookmark check shareMap", retShare);
          if (retShare != null) {
            retShare.serial = retShare.id;
            bookmarkedHaikuboxes.push(retShare);
          }
        }
      }
      this.bookmarkedDevices = bookmarkedHaikuboxes;
      // console.log("bookmarked Haikbuoxes", this.bookmarkedDevices);
    },
    async getDevices() {
      var nextToken = null;
      var allDevices = [];
      var connected = [];
      do {
        const deviceStates = await API.graphql({
          query: listShareMaps,
          variables: { nextToken: nextToken },
        });
        allDevices = allDevices.concat(deviceStates.data.listShareMaps.items);
        nextToken = deviceStates.data.listShareMaps.nextToken;
        deviceStates.data.listShareMaps.items.forEach(function (element) {
          // console.log("Element", element);
          element.serial = element.id;
          if ((element.shareLat != null) & element.connected) {
            connected.push(element);
          }

        });
        this.connectedDevices = connected;
      } while (nextToken != null);

      // console.log("Devices", this.devices);

      // var disconnected = [];

      // this.disconnectedDevices = disconnected;
      // console.log("connected", connected);
      // console.log("disconnected", disconnected);

      // this.isFetchingBoxes = false;
    },
    async checkConnection(serialClicked) {
      await this.getStatus(serialClicked);
      if (this.currentWiFi == 0) {
        this.checkConnectionFailed = true;
      } else {
        this.checkConnectionFailed = false;
      }
    },
    async getStatus(serialClicked) {
      let yesterdayDate = moment.utc().subtract(1, "hours").format();
      const filterArg = {
        serial: serialClicked,
        createdAt: { gt: yesterdayDate },
      };
      const boxStatus = await API.graphql({
        query: statusByDate,
        variables: filterArg,
        sortDirection: "ASC",
      });
      this.haikuboxStatus = boxStatus.data.statusByDate.items;
      // console.log('getStatus', this.haikuboxStatus);
      var currentWiFi = 0;
      this.lastStatusUpdate = "";
      if (this.haikuboxStatus.length > 0) {
        currentWiFi =
          this.haikuboxStatus[this.haikuboxStatus.length - 1].signal;
        this.lastStatusUpdate = moment(
          this.haikuboxStatus[this.haikuboxStatus.length - 1].updatedAt,
          "YYYY-MM-DDThh:mm:ssZ"
        ).calendar();
        this.wifiUpdatedAt = moment(
          this.haikuboxStatus[this.haikuboxStatus.length - 1].updatedAt
        )
          .local()
          .calendar();
      }

      this.currentWiFi = currentWiFi;

      // console.log('wifi last updated', this.haikuboxStatus[this.haikuboxStatus.length-1].updatedAt);
    },
    // fusioncharts format hourly data
    async getHourlySpecies(cn) {
      let hourlyTimeSeries = Array(24).fill(0);
      var nextToken = null;
      this.lastUpdated = moment
        .utc()
        .local()
        .locale(this.selectedLanguage)
        .calendar();
      let yesterdayDate, todayDate;
      var tempHits = [];

      todayDate = moment.utc().format();

      yesterdayDate = moment.utc().subtract(23, "hours").format();
      // console.log(cn, yesterdayDate, todayDate, this.currentSerial)
      do {
        const queryHits = await API.graphql({
          query: hitsBySpeciesByDate,
          variables: {
            serial: this.currentSerial,
            cnDt: {
              between: [
                { cn: cn, dt: yesterdayDate },
                { cn: cn, dt: todayDate },
              ],
            },
            sortDirection: "DESC",
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(queryHits.data.hitsBySpeciesByDate.items);
        nextToken = queryHits.data.hitsBySpeciesByDate.nextToken;
      } while (nextToken != null);

      // console.log(tempHits);
      // loop through all detections and add to correct hour bin
      // localHour will correspond to bin index 23
      tempHits.forEach((hit) => {
        var currentMinutes = moment.utc().minutes();
        // convert to local time to get correct hour bin
        var diffMinutes = moment.utc(hit["dt"]).diff(todayDate, "minutes");
        var diffHours = moment.utc(hit["dt"]).diff(todayDate, "hours");
        if ((diffHours == 0) & (-diffMinutes > currentMinutes)) diffHours = -1; // round current hour
        // console.log('diff from now', currentMinutes, diffMinutes, diffHours);
        var i = 23 + diffHours;
        if (i < 0) i = 0;
        if (i > 23) i = 23;
        hourlyTimeSeries[i] = hourlyTimeSeries[i] + hit["detectionCount"];
      });
      // console.log("UTC", hourlyTimeSeries);

      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate).utc();
        stopDate = moment(stopDate).utc();
        // console.log("start date", startDate);
        // console.log("stop date", stopDate);
        while (currentDate <= stopDate) {
          var a = moment.utc(currentDate);
          dateArray.push(a.format());
          currentDate = moment(currentDate).add(1, "hours");
        }
        return dateArray;
      }

      let minMomentDate = moment.utc().subtract(23, "hours");
      minMomentDate.minutes(0);
      minMomentDate.seconds(0);
      let minDate = minMomentDate.format();
      let maxDate = minMomentDate.add(23, "hours").format();
      let dateArr = getDates(minDate, maxDate);
      let localDateArr = [];
      for (let utcDate of dateArr) {
        localDateArr.push([
          moment.utc(utcDate).tz(this.currentTimezone).format("hh:mm a"),
        ]);
      }

      this.chartOptionsHourly = {
        xaxis: {
          categories: localDateArr,
        },
      };

      this.chartOptionsSpeciesHourly = {
        xaxis: {
          categories: localDateArr,
        },
      };

      // console.log(localDateArr);
      // console.log(this.chartOptionsHourly);
      // console.log(this.chartOptionsSpeciesHourly);

      var colorMap = [
        "#ffffd9",
        "#edf8b1",
        "#c7e9b4",
        "#7fcdbb",
        "#41b6c4",
        "#1d91c0",
        "#225ea8",
        "#0c2c84",
      ];

      // console.log("speciesID", speciesID);
      var totalDetections = 0;
      var plotData = [];

      var localHour;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "12:00 am")
        localHour = 0;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "01:00 am")
        localHour = 1;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "02:00 am")
        localHour = 2;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "03:00 am")
        localHour = 3;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "04:00 am")
        localHour = 4;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "05:00 am")
        localHour = 5;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "06:00 am")
        localHour = 6;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "07:00 am")
        localHour = 7;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "08:00 am")
        localHour = 8;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "09:00 am")
        localHour = 9;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "10:00 am")
        localHour = 10;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "11:00 am")
        localHour = 11;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "12:00 pm")
        localHour = 12;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "01:00 pm")
        localHour = 13;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "02:00 pm")
        localHour = 14;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "03:00 pm")
        localHour = 15;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "04:00 pm")
        localHour = 16;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "05:00 pm")
        localHour = 17;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "06:00 pm")
        localHour = 18;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "07:00 pm")
        localHour = 19;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "08:00 pm")
        localHour = 20;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "09:00 pm")
        localHour = 21;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "10:00 pm")
        localHour = 22;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "11:00 pm")
        localHour = 23;
      var startingAngle = 260 - localHour * (360 / 24);
      if (startingAngle < 0) startingAngle += 360;
      // console.log('localHour', localHour);
      // console.log("startingAngle", startingAngle);

      for (var i = 23; i > -1; i--) {
        var colorMapIndex = 0;
        if (hourlyTimeSeries[i] > 0) colorMapIndex = 1;
        if (hourlyTimeSeries[i] > 1) colorMapIndex = 2;
        if (hourlyTimeSeries[i] > 2) colorMapIndex = 3;
        if (hourlyTimeSeries[i] > 5) colorMapIndex = 4;
        if (hourlyTimeSeries[i] > 10) colorMapIndex = 5;
        if (hourlyTimeSeries[i] > 15) colorMapIndex = 6;
        if (hourlyTimeSeries[i] > 20) colorMapIndex = 7;
        totalDetections += hourlyTimeSeries[i];
        var dateText = this.chartOptionsSpeciesHourly.xaxis.categories[i];
        var showLabel = 0;
        var isSliced = 0;
        var dateTextDict = {
          "12:00 am": "midnight",
          "01:00 am": "1am",
          "02:00 am": "2am",
          "03:00 am": "3am",
          "04:00 am": "4am",
          "05:00 am": "5am",
          "06:00 am": "6am",
          "07:00 am": "7am",
          "08:00 am": "8am",
          "09:00 am": "9am",
          "10:00 am": "10am",
          "11:00 am": "11am",
          "12:00 pm": "noon",
          "01:00 pm": "1pm",
          "02:00 pm": "2pm",
          "03:00 pm": "3pm",
          "04:00 pm": "4pm",
          "05:00 pm": "5pm",
          "06:00 pm": "6pm",
          "07:00 pm": "7pm",
          "08:00 pm": "8pm",
          "09:00 pm": "9pm",
          "10:00 pm": "10pm",
          "11:00 pm": "11pm",
        };
        if (dateText == "12:00 am") showLabel = 1;
        if (dateText == "12:00 pm") showLabel = 1;
        if (dateText == "06:00 pm") showLabel = 1;
        if (dateText == "06:00 am") showLabel = 1;
        if (i == 23) isSliced = 1;
        plotData.push({
          label: dateTextDict[dateText],
          value: 100,
          color: colorMap[colorMapIndex],
          showLabel: showLabel,
          isSliced: isSliced,
          tooltext:
            dateTextDict[dateText] + ":" + hourlyTimeSeries[i].toString(),
        });
      }
      // console.log("hourly plotData", plotData);
      // console.log("totalDetections", totalDetections);

      var fusionDataset = {
        chart: {
          caption: "Past 24h",
          numberPrefix: "",
          bgColor: "#ffffff",
          startingAngle: startingAngle.toString(),
          showLegend: "0",
          enableSmartLabels: "1",
          showLabels: "0",
          showValues: "0",
          defaultCenterLabel: totalDetections.toString(),
          centerLabelFontSize: "18",
          centerLabelBold: "1",
          enableMultiSlicing: "0",
          animateClockwise: "1",
          showPercentInToolTip: "0",
        },
        data: plotData,
      };
      // console.log("fusionDataset", fusionDataset);
      return fusionDataset;
    },

    async getHeatmap(cn) {
      let nDays = 14;
      var nextToken = null;
      // this.lastUpdated = moment.utc().local().locale(this.selectedLanguage).calendar();
      let startDate, todayDate, refDate;
      var tempHits = [];

      refDate = moment.utc();
      todayDate = moment.utc().format();
      startDate = moment.utc().subtract(nDays, "days").format();
      // console.log(todayDate);
      if (this.recentHours == 0) {
        refDate = moment(this.hitDatePicker).utc();
        todayDate = moment(this.hitDatePicker).utc().format();
        startDate = moment(this.hitDatePicker).utc().subtract(nDays, "days").format();
      }      
      // console.log(startDate, todayDate, this.currentSerial)
      do {
        const queryHits = await API.graphql({
          query: hitsBySpeciesByDate,
          variables: {
            serial: this.currentSerial,
            cnDt: {
              between: [
                { cn: cn, dt: startDate },
                { cn: cn, dt: todayDate },
              ],
            },
            sortDirection: "DESC",
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(queryHits.data.hitsBySpeciesByDate.items);
        nextToken = queryHits.data.hitsBySpeciesByDate.nextToken;
      } while (nextToken != null);
      // console.log(tempHits);

      // data are in rows; each row is a single hour for all days
      // create empty array with zeros
      var heatmapData = [];

      for (var i = 0; i < 24; i++) {
        const zerosArray = Array(nDays).fill(0); // this needs to be in the loop to clone the array (otherwise all rows end up with same value)
        heatmapData.push(zerosArray);
      }
      // loop through all detections and add to correct hour and day bin
      tempHits.forEach((hit) => {
        // To Do: convert to local time to get correct hour and date bin
        var hourBin = moment.utc(hit["dt"]).tz(this.currentTimezone).hour();
        var hitDate = moment.utc(hit["dt"]).tz(this.currentTimezone).diff(refDate.tz(this.currentTimezone).endOf('day'), "days");
        let dayBin = nDays + hitDate - 1;

        // increment heatmap
        // console.log('hit["dt"], day hourBin dayBin heatmap cell',hit["dt"], hitDate, hourBin, dayBin);
        heatmapData[hourBin][dayBin] += hit["detectionCount"];
      });

      const formattedDates = [];
      // Loop through the dates and format them as "MMM D" (e.g., "Oct 1", "Oct 2", ...)
      for (let i = nDays - 1; i >= 0; i--) {
        // Assuming you want 31 days for October
        let formattedDate = moment
          .utc()
          .tz(this.currentTimezone)
          .subtract(i, "days")
          .format("MMM D");

        if (this.recentHours == 0) {
          formattedDate = moment(this.hitDatePicker)
          .utc()
          .tz(this.currentTimezone)
          .subtract(i, "days")
          .format("MMM D");
        }
        formattedDates.push(formattedDate);
      }
      const formattedHours = [];
      for (let i = 0; i < 24; i++) {
        formattedHours.push(i + ":" + "00");
      }

      var heatmap = [
        {
          x: formattedDates,
          y: formattedHours,
          z: heatmapData,
          type: "heatmap",
          showscale: true,
          hoverongaps: false,
        },
      ];

      return heatmap;
    },

    // for charts.js plots
    async getDailySpeciesChartsJS(commonName) {
      // query daily table to get time series for year
      // console.log("getDailyCountsBySpecies commonName", commonName);

      var nextToken = null;
      var dailyCounts = [];
      do {
        const dailyCountSummary = await API.graphql({
          query: dailyCountSummaryBySerialBySpecies,
          variables: {
            serial: this.currentSerial,
            cn: { eq: commonName },
            nextToken: nextToken,
          },
        });
        dailyCounts = dailyCounts.concat(
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.items
        );
        nextToken =
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("daily counts", dailyCounts);

      // Create date array in case dates with no results
      let maxDate = moment.utc().format();
      let minDate = moment.utc().subtract(90, "days").format();
      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
      }
      let dateArr = getDates(minDate, maxDate);
      function getShortDates(startDate, stopDate) {
        var shortDateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          shortDateArray.push(moment(currentDate).format("MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return shortDateArray;
      }
      let shortDateArr = getShortDates(minDate, maxDate);
      // console.log('dateArr', dateArr);
      // console.log('shortDateArr', shortDateArr);

      //
      // dailyCounts is sparse; add missing dates
      //

      // dateList will hold array of all dates to plot
      var dateList = [];
      for (let item in dailyCounts) {
        dateList.push(dailyCounts[item]["countDate"]);
      }
      // console.log('dateList', dateList);

      // create array with zeros
      let countArray = [];
      for (let i = 0; i < countArray.length; i++) {
        countArray.push(0);
      }

      // loop through all dates with counts and subsitute actual count in countArray
      for (let i in dateList) {
        let countIndex = dateArr.indexOf(dateList[i]);
        countArray[countIndex] = dailyCounts[i].countsPerDay;
      }

      //console.log("countArray", countArray);

      var dailyCountPlotData = [];
      for (let item in dateArr) {
        dailyCountPlotData.push([shortDateArr[item], countArray[item]]);
      }
      // console.log("dailyCountPlotData", dailyCountPlotData);
      return dailyCountPlotData;
    },
    // Daily count for fusion charts plot
    async getDailyCountsBySpecies(commonName) {
      // query daily table to get time series for year
      // console.log("getDailyCountsBySpecies commonName", commonName);
      var nextToken = null;
      var dailyCounts = [];
      do {
        const dailyCountSummary = await API.graphql({
          query: dailyCountSummaryBySerialBySpecies,
          variables: {
            serial: this.currentSerial,
            cn: { eq: commonName },
            nextToken: nextToken,
          },
        });
        dailyCounts = dailyCounts.concat(
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.items
        );
        nextToken =
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("daily counts", dailyCounts);

      var dailyCountPlotData = [];

      for (let item in dailyCounts) {
        dailyCountPlotData.push([
          dailyCounts[item]["countDate"],
          dailyCounts[item]["countsPerDay"],
        ]);
      }
      const fusionDataStore = new FusionCharts.DataStore();
      const fusionTable = fusionDataStore.createDataTable(
        dailyCountPlotData,
        this.fusionSchemaDaily
      );
      return fusionTable;
    },
    async getYesterdayCounts(serial) {
      let yesterdayDate = moment
        .utc()
        .local()
        .subtract(24, "hours")
        .format("YYYY-MM-DD");
      var nextToken = null;
      var yesterdayCountsAll = [];
      do {
        const returnCount = await API.graphql({
          query: dailyCountSummaryBySerialByDate,
          variables: {
            serial: serial,
            countDate: { eq: yesterdayDate },
            nextToken: nextToken,
          },
        });
        yesterdayCountsAll = yesterdayCountsAll.concat(
          returnCount.data.dailyCountSummaryBySerialByDate.items
        );
        nextToken = returnCount.data.dailyCountSummaryBySerialByDate.nextToken;
      } while (nextToken != null);

      var callsAndSongs = 0;
      var mostFrequent = "";
      var mostFrequentspCode = "";
      var maxCount = 0;
      var speciesCount = 0;
      // console.log("getYesterdayCounts", yesterdayDate, yesterdayCountsAll);
      var dailySummaryList = [];
      for (let i = 0; i < yesterdayCountsAll.length; i++) {
        if (!this.hiddenList.includes(yesterdayCountsAll[i].cn)) {
          dailySummaryList.push(yesterdayCountsAll[i]);
          callsAndSongs += yesterdayCountsAll[i].countsPerDay;
          speciesCount++;
          if (yesterdayCountsAll[i].countsPerDay > maxCount) {
            maxCount = yesterdayCountsAll[i].countsPerDay;
            mostFrequent = yesterdayCountsAll[i].cn;
            mostFrequentspCode = yesterdayCountsAll[i].spCode;
          }
        }
      }
      //console.log('dailySummaryList', dailySummaryList);
      // sort list by abundance
      dailySummaryList.sort((a, b) =>
        a.countsPerDay < b.countsPerDay ? 1 : -1
      );
      this.dailySummaryList = dailySummaryList;
      this.dailySummaryDate = moment
        .utc()
        .local()
        .subtract(24, "hours")
        .format("dddd, MMMM Do YYYY");

      this.yesterdayNumSpecies = speciesCount;
      this.yesterdayCallsAndSongs = callsAndSongs;
      this.yesterdayMostFrequent = mostFrequent;
      this.yesterdaySpCode = mostFrequentspCode;

      // get change in activity for birds detected yesterdayl
      let twoDaysAgo = moment
        .utc()
        .local()
        .subtract(48, "hours")
        .format("YYYY-MM-DD");

      var moreActiveSpeciesList = [];
      for (let i = 0; i < yesterdayCountsAll.length; i++) {
        // if had at least 10 detections yesterday, check to see if increasing pattern
        if (
          (yesterdayCountsAll[i].countsPerDay > 9) &
          !this.hiddenList.includes(yesterdayCountsAll[i].cn)
        ) {
          let summaryId =
            this.currentSerial +
            "_" +
            yesterdayCountsAll[i].spCode +
            "_" +
            twoDaysAgo;
          const dailyCountSummary = await API.graphql({
            query: getDailyCountSummary,
            variables: { id: summaryId },
          });
          const dailyCounts = dailyCountSummary.data.getDailyCountSummary;
          // console.log(yesterdayCountsAll[i].cn, dailyCounts);
          if (dailyCounts !== null) {
            if (dailyCounts["countsPerDay"] < 4) {
              // console.log("more active species", yesterdayCountsAll[i].cn);
              moreActiveSpeciesList.push(yesterdayCountsAll[i]);
            }
          } else {
            // console.log("more active species", yesterdayCountsAll[i].cn);
            moreActiveSpeciesList.push(yesterdayCountsAll[i]);
          }
        }
        this.moreActiveSpeciesList = moreActiveSpeciesList.slice(0, 3);
      }
    },
    hitSelectDate() {
      // console.log('hitsSelectRange');
      if (this.hitCalendarDatePicked == false) {
        this.hitCalendarDatePicked = true; // hide calendar
      } else {
        this.hitCalendarDatePicked = false; // show calendar
        this.recentHours = 0;
      }
    },
    hitDateClick() {
      // console.log('hitDateClick', this.hitDatePicker);
      this.logClick("calendar", "", "");
      this.hitCalendarDatePicked = true; // hide calendar
      this.changeRecentHours(0);
    },
    setViewSettings(viewSetting) {
      // console.log("setViewSettings", viewSetting);
      this.viewSettings = viewSetting;
      this.logClick("setViewSettings_" + viewSetting, "", "");
      if (viewSetting == "Low") {
        this.confidenceThreshold = 0.0;
        this.specSumThreshold = -1;
      }
      if (viewSetting == "Medium") {
        this.confidenceThreshold = 0.4;
        this.specSumThreshold = 2;
      }
      if (viewSetting == "High") {
        this.confidenceThreshold = 0.9;
        this.specSumThreshold = 6;
      }
      localStorage.setItem('haikuboxConfidence', viewSetting);
      this.clickRefresh(this.currentSerial);
    },
    setViewConfidence(viewSetting){
      // console.log("setViewConfidence", viewSetting);
      if (viewSetting == "Low") {
        this.confidenceThreshold = 0.0;
        this.specSumThreshold = -1;
      }
      if (viewSetting == "Medium") {
        this.confidenceThreshold = 0.4;
        this.specSumThreshold = 2;
      }
      if (viewSetting == "High") {
        this.confidenceThreshold = 0.9;
        this.specSumThreshold = 6;
      }
    },
    async getHits(serialClicked) {
      //console.log("getHits", serialClicked);
      var nextToken = null;
      this.lastUpdated = moment
        .utc()
        .local()
        .locale(this.selectedLanguage)
        .calendar();
      let yesterdayDate;
      var tempHits = [];
      var tempHits2 = [];

      if (this.recentHours > 0) {
        yesterdayDate = moment
          .utc()
          .subtract(this.recentHours, "hours")
          .format();
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: serialClicked,
              dt: { gt: yesterdayDate },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
            filter: { wav: { gt: "" } },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = tempHits.length;
        } while (nextToken != null);
      }
      if (this.recentHours == 0) {
        let startDate = moment(this.hitDatePicker)
          .tz(this.currentTimezone)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");
        let endDate = moment(startDate)
          .add(24, "hours")
          .format("YYYY-MM-DDTHH:mm:ss");
        // console.log('query hits ', startDate, endDate)
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: serialClicked,
              dt: { between: [startDate, endDate] },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
            filter: { wav: { gt: "" } },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = tempHits.length;
        } while (nextToken != null);
      }

      // filter allHits
      // console.log('tempHits', tempHits);

      for (var i = 0; i < tempHits.length; i++) {
        if (
          !this.hiddenList.includes(tempHits[i].cn) &
          (tempHits[i].wav != "")
        ) {
          if (
            tempHits[i].score > this.confidenceThreshold &&
            tempHits[i].specSum > this.specSumThreshold
          )
            tempHits2.push(tempHits[i]);
        }
      }

      // console.log('tempHits2', tempHits2);
      this.allHits = tempHits2;

      // keep track of species in list and put wav files in list
      var speciesHits = [];
      var uniqueHits = [];
      var speciesDict = {};
      var counter = 0;

      for (i = 0; i < tempHits2.length; i++) {
        // var splitWav = tempHits2[i]["wav"].split("_");
        //var wavTimeStamp = splitWav[3].slice(0, -5);
        var wavTimeStamp = tempHits2[i].dt;
        // console.log(wavTimeStamp, this.currentTimezone)
        // let wavTimeMoment = moment(wavTimeStamp).fromNow();
        var wavTimeMoment = moment
          .utc(wavTimeStamp)
          .tz(this.currentTimezone)
          .locale(this.selectedLanguage)
          .format('ll LTS');

        // console.log(splitWav, wavTimeStamp);
        // console.log(wavTimeMoment);

        // use for quick check of low scores
        // var listname = "L " + tempHits2[i].score) + ' ' + wavTimeMoment;
        var listname = "L " + wavTimeMoment;
        if ((tempHits2[i].score > 0.4) & (tempHits2[i].specSum > 2)) {
          listname = "M " + wavTimeMoment;
        }
        if (tempHits2[i].score > 0.9 && tempHits2[i].specSum > 6) {
          listname = "H " + wavTimeMoment;
        }

        if (
          tempHits2[i].score < 0.4 &&
          (tempHits2[i].version.slice(-1) == "D" | tempHits2[i].version.slice(-2) == "6")
        ) {
          listname = "L. " + wavTimeMoment;
        }

        if (
          tempHits2[i].score > 0.4 &&
          tempHits2[i].specSum > 3 &&
          (tempHits2[i].version.slice(-1) == "D" | tempHits2[i].version.slice(-2) == "6")
        ) {
          listname = "M. " + wavTimeMoment;
        }
        if (
          tempHits2[i].score > 0.9 &&
          tempHits2[i].specSum > 5 &&
          (tempHits2[i].version.slice(-1) == "D"  | tempHits2[i].version.slice(-2) == "6")
        ) {
          listname = "H. " + wavTimeMoment;
        }

        if (!speciesHits.includes(tempHits2[i].cn)) {
          speciesHits.push(tempHits2[i].cn);
          speciesDict[tempHits2[i].cn] = counter;
          uniqueHits.push(tempHits2[i]);
          uniqueHits[counter].wavList = [
            {
              filename: tempHits2[i]["wav"],
              listname: listname,
              dt: tempHits2[i]["dt"],
              score: tempHits2[i]["score"],
              specSum: tempHits2[i]["specSum"],
            },
          ];
          uniqueHits[counter].currentWav = {
            filename: tempHits2[i]["wav"],
            listname: listname,
            dt: tempHits2[i]["dt"],
            score: tempHits2[i]["score"],
            specSum: tempHits2[i]["specSum"],
          };
          uniqueHits[counter].playbackIndex = 0;
          uniqueHits[counter].window = "image";
          uniqueHits[counter].showBird = true;
          uniqueHits[counter].notifyBird = false;
          counter = counter + 1;
        } else {
          uniqueHits[speciesDict[tempHits2[i].cn]]["wavList"].push({
            filename: tempHits2[i]["wav"],
            listname: listname,
            dt: tempHits2[i]["dt"],
            score: tempHits2[i]["score"],
            specSum: tempHits2[i]["specSum"],
          });
        }
      }
      // console.log('speciesHits', speciesHits);
      // console.log('speciesDict', speciesDict);
      // console.log("uniqueHits", uniqueHits);

      

      // If only 1 wav file for a species and confidence is set to MED or HIGH remove from list
      if(this.confidenceThreshold >=0.4){
        for (i = uniqueHits.length - 1; i>=0; i--) {
          if (uniqueHits[i].wavList.length == 1){
            // console.log("delete single detection", uniqueHits[i].cn);
            uniqueHits.splice(i, 1); // remove and shift object
          }
        }
      }
      else{  
        // If only 1 wav file for a species and confidence is set to LOW, change confidence to LOW
        for (i = uniqueHits.length - 1; i>=0; i--) {
          if (uniqueHits[i].wavList.length == 1){
            var listname = uniqueHits[i].wavList[0].listname;
            var listnameL = 'L' + listname.slice(1);
            uniqueHits[i].wavList[0].listname = listnameL;
          }
        }
      }

      // Check if clips > 3s
      if(uniqueHits.length>0){
        // console.log(uniqueHits[0].wav[5]);
        this.maxClipSeconds = 3;
        this.clipSeconds = 3;
        if(uniqueHits[0].wav[5]=='P') this.maxClipSeconds = 12; // haiku3
        if(uniqueHits[0].wav[9]=='M') this.maxClipSeconds = 12; // haikumarine
      }

      // query hidden list for this Haikubox
      // query hideBirds condition for this Haikubox
      const returnCount = await API.graphql({
        query: hideBirdBySerial,
        variables: {
          serial: this.currentSerial,
        },
      });
      // console.log('hideBirdBySerial', returnCount.data.hideBirdBySerial.items);
      let hiddenBirdList = returnCount.data.hideBirdBySerial.items;
      let customHiddenList = [];
      for (let i = 0; i < hiddenBirdList.length; i++) {
        customHiddenList.push(hiddenBirdList[i].cn);
      }

      // query notify birds
      var nextToken = null;
      let notifyBirdList = [];
      do {
        const notify = await API.graphql({
          query: notifyBirdBySerial,
          variables: {
            serial: this.currentSerial,
            nextToken: nextToken,
          },
        });
        notifyBirdList = notifyBirdList.concat(
          notify.data.notifyBirdBySerial.items
        );
        nextToken = notify.data.notifyBirdBySerial.nextToken;
      } while (nextToken != null);

      let customNotifyList = [];
      // console.log('notifyBirdList', notifyBirdList);
      for (let i = 0; i < notifyBirdList.length; i++) {
        customNotifyList.push(notifyBirdList[i].cn);
      }

      // update hits with notifyBird
      for (i in uniqueHits) {
        if (customNotifyList.includes(uniqueHits[i].cn)) {
          uniqueHits[i].notifyBird = true;
          // console.log("notify index and species", i, uniqueHits[i]);
        }
      }

      // update hits with showBird and
      for (i = uniqueHits.length - 1; i >= 0; i--) {
        // console.log("unique hits", i, uniqueHits[i].cn)
        if (customHiddenList.includes(uniqueHits[i].cn)) {
          // console.log("hide bird", uniqueHits[i].cn)
          uniqueHits.splice(i, 1);
        }
      }

      // query favorites
      for (i = uniqueHits.length - 1; i >= 0; i--) {
        uniqueHits[i].favoriteHit = false;
        // console.log(uniqueHits[i].currentWav.filename);
        const favoriteHit = await API.graphql({
          query: getFavoriteHit,
          variables: {
            id: uniqueHits[i].wav,
          },
        });
        if (favoriteHit.data.getFavoriteHit != null) {
          uniqueHits[i].favoriteHit = true;
          // console.log('getHits favorite', favoriteHit);
        }
      }

      this.hits = uniqueHits; // this.hits is what is looped through to show cards
      // console.log("hits", this.hits);
      this.hitsLoading = 0; // hide hits loading counter
    },
    async getAll(serial) {
      this.seriesDaily = [];
      var startYear = "2022";
      // console.log("getAll", currentYear);

      var nextToken = null;
      var yearlyCountsAll = [];

      do {
        const returnCount = await API.graphql({
          query: yearlyCountSummaryBySerialByYear,
          variables: {
            serial: serial,
            countYear: { ge: startYear },
            nextToken: nextToken,
          },
        });
        yearlyCountsAll = yearlyCountsAll.concat(
          returnCount.data.yearlyCountSummaryBySerialByYear.items
        );
        nextToken = returnCount.data.yearlyCountSummaryBySerialByYear.nextToken;
      } while (nextToken != null);

      // console.log("yearly counts All", yearlyCountsAll);
      // sum and remove duplicates to get total
      var k = 0;
      while (k < yearlyCountsAll.length) {
        for (let i = yearlyCountsAll.length - 1; i > k; i--) {
          // if found a match add count and remove match
          if (yearlyCountsAll[k].cn == yearlyCountsAll[i].cn) {
            yearlyCountsAll[k].countsTotal += yearlyCountsAll[i].countsTotal;
            yearlyCountsAll.splice(i, 1);
          }
        }
        k++;
        // console.log(k);
      }

      // sort by totalCount
      yearlyCountsAll.sort(function (a, b) {
        var keyA = a.countsTotal,
          keyB = b.countsTotal;
        // Compare the 2 counts
        if (keyA > keyB) return -1;
        if (keyA < keyB) return 1;
        return 0;
      });
      // console.log("yearly counts All sorted", yearlyCountsAll);

      // query hideBirds condition for this Haikubox
      const returnCount = await API.graphql({
        query: hideBirdBySerial,
        variables: {
          serial: this.currentSerial,
        },
      });
      // console.log('hideBirdBySerial', returnCount.data.hideBirdBySerial.items);
      let hiddenBirdList = returnCount.data.hideBirdBySerial.items;
      let customHiddenList = [];
      for (let i = 0; i < hiddenBirdList.length; i++) {
        customHiddenList.push(hiddenBirdList[i].cn);
      }
      // console.log('customHiddenList', customHiddenList);

      // query notify birds
      var nextToken = null;
      let notifyBirdList = [];
      do {
        const notify = await API.graphql({
          query: notifyBirdBySerial,
          variables: {
            serial: this.currentSerial,
            nextToken: nextToken,
          },
        });
        notifyBirdList = notifyBirdList.concat(
          notify.data.notifyBirdBySerial.items
        );
        nextToken = notify.data.notifyBirdBySerial.nextToken;
      } while (nextToken != null);

      let customNotifyList = [];
      // console.log('notifyBirdList', notifyBirdList);
      for (let i = 0; i < notifyBirdList.length; i++) {
        customNotifyList.push(notifyBirdList[i].cn);
      }
      // remove hidden birds and set showBird and notifyBird
      for (let i = yearlyCountsAll.length - 1; i >= 0; i--) {
        if (this.hiddenList.includes(yearlyCountsAll[i].cn)) {
          yearlyCountsAll.splice(i, 1);
        } else {
          yearlyCountsAll[i].showBird = true;
          if (customHiddenList.includes(yearlyCountsAll[i].cn))
            yearlyCountsAll[i].showBird = false;
          yearlyCountsAll[i].notifyBird = false;
          if (customNotifyList.includes(yearlyCountsAll[i].cn)) {
            yearlyCountsAll[i].notifyBird = true;
          }
        }
      }
      var dailyDataSource = {
        data: null,
        legend: {
          enabled: "0",
        },
        navigator: {
          enabled: 0,
        },
        extensions: {
          customRangeSelector: {
            enabled: "0",
          },
        },
        yAxis: [
          {
            plot: {
              value: "Detections",
              type: "column",
            },
            format: {
              prefix: "",
            },
            title: "Count",
          },
        ],
      };
      this.allSpeciesList = [];
      this.speciesSelected = "";
      this.scrolledToBottom = false;
      for (let i in yearlyCountsAll) {
        yearlyCountsAll[i].dataSource = { ...dailyDataSource }; //spread operator to make deep copy
        this.allSpeciesList.push(
          this.t(yearlyCountsAll[i].spCode, yearlyCountsAll[i].cn)
        );
      }
      this.seriesDaily = yearlyCountsAll;
      // console.log('yearlyCountsAll', yearlyCountsAll);
      // console.log("seriesDaily", this.seriesDaily);
    },
    async getMapCountsPerSpecies(commonName) {
      let yesterdayDate = moment
        .utc()
        .local()
        .subtract(24, "hours")
        .format("YYYY-MM-DD");
      var tempHits = [];
      var nextToken = null;
      do {
        const queryHits = await API.graphql({
          query: dailyCountSummaryByDateBySpecies,
          variables: {
            cn: { eq: commonName },
            countDate: yesterdayDate,
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(
          queryHits.data.dailyCountSummaryByDateBySpecies.items
        );
        nextToken = queryHits.data.dailyCountSummaryByDateBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("getMapCountsPerSpecies tempHits", tempHits);
      var mapHits = [];
      for (let i = 0; i < tempHits.length; i++) {
        let mapCount = {
          lat: tempHits[i].lat,
          lon: tempHits[i].lon,
          radius: tempHits[i].countsPerDay * 100,
        };
        mapHits.push(mapCount);
      }
      return mapHits;
    },
    float2int(value) {
      return value | 0;
    },
    async setWindowRecent(index, value, spCode, commonName) {
      this.logClick("setWindowRecent_" + value, spCode, commonName);

      if (value == "daily") {
        this.hits[index].hourlyCountPlotData = await this.getHourlySpecies(
          commonName
        );
      }
      if (value == "monthly") {
        this.hits[index].dailyCountPlotData =
          await this.getDailySpeciesChartsJS(commonName);
      }
      if (value == "heatmap") {
        this.hits[index].heatmap = await this.getHeatmap(commonName);
      }
      if (value == "map") {
        this.hits[index].map = await this.getMapCountsPerSpecies(commonName);
      }
      this.hits[index].window = value;
      this.$forceUpdate(); 
     // this.hits[index].id += 1; // increment ID so that component updates
     // console.log('setWindowRecent', this.hits[index]);
      // console.log("setWindowRecent", commonName, this.hits[index]);
    },
    async setWindowAll(index, value, spCode, commonName) {
      this.logClick("setWindowAll_" + value, spCode, commonName);
      // console.log("setWindowAll", index, value, commonName);
      if (this.seriesDaily[index].window == value)
        this.seriesDaily[index].window = "none";
      // toggle view
      else {
        if (value == "monthly") {
          this.seriesDaily[index].dataSource.data =
            await this.getDailyCountsBySpecies(commonName);
        }
        this.seriesDaily[index].window = value;
      }
      this.seriesDaily[index].id += 1; // increment ID so that component updates
      // console.log("setWindowAll", this.seriesDaily[index]);
    },
    setWindowNew(index, value) {
      this.newSpeciesList[index].window = value;
      this.newSpeciesList[index].id += 1; // increment ID so that component updates
      // console.log("Change Window", this.hits[index]);
    },
    setWindowMissing(index, value) {
      this.missingSpeciesList[index].window = value;
      this.missingSpeciesList[index].id += 1; // increment ID so that component updates
      // console.log("Change Window", this.hits[index]);
    },
    async getNotices() {
      const userNotices = await API.graphql({
        query: userNoticeByOwnerByViewed,
        variables: {
          owner: this.user,
          noticeViewed: { eq: "False" },
        },
      });
      // console.log(userNotices.data.userNoticeByOwnerByViewed.items);
      var tempNotices = userNotices.data.userNoticeByOwnerByViewed.items;
      var tempNoticeDescriptions = [];
      for (var i = 0; i < tempNotices.length; i++) {
        const nD = await API.graphql({
          query: getNoticeDescription,
          variables: {
            id: tempNotices[i].noticeID,
          },
        });
        // console.log(nD.data.getNoticeDescription);
        tempNoticeDescriptions.push(nD.data.getNoticeDescription);
      }
      this.userNotices = tempNoticeDescriptions;
    },
    async acknowledgeNotice(noticeID) {
      // set notice to True (read)
      var id = noticeID + "-" + this.user;
      var owner = this.user;
      var noticeViewed = "True";
      const noticeData = {
        id,
        owner,
        noticeViewed,
      };

      await API.graphql({
        query: updateUserNotice,
        variables: { input: noticeData },
      });

      this.getNotices(); // this will clear the notice
    },
    async getWavFileName(index, spCode, cn, pageType, pipeTo, audioFile) {
      //console.log(audioFile)
      // hitsBySpecies
      if (pageType === "Increasing") {
        // To Do:
        // move increasing into yesterday summary)
      }

      if ((audioFile != "") & (pipeTo === "spectrogram"))
        this.spectrogram(index, audioFile, pageType);
      if ((audioFile != "") & (pipeTo === "play"))
        this.playFile(audioFile, spCode, cn);
    },
    spectrogram(index, audioFile, pageType) {
      // console.log("Spectrogram", index, audioFile, pageType);

      this.initAudioContext();

      async function getFile(audioContext, filepath) {
        // webkit audio decodeAudioData does not work in Safari
        // const response = await fetch(filepath);
        // const arrayBuffer = await response.arrayBuffer();
        // const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        // return audioBuffer;

        // standardized-audio-context from npm
        // const nativeAudioContext = new AudioContext();
        const response = await fetch(filepath);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await decodeAudioData(
          globalAudioContext,
          arrayBuffer
        );
        return audioBuffer;
      }

      async function setupSample(filePath) {
        // var context = new AudioContext();
        const sample = await getFile(globalAudioContext, filePath);

        return sample;
      }

      function linear2Decibel(value) {
        var dB = 20 * Math.log10(value);
        return dB;
      }

      //var c = document.getElementById("myCanvas");
      //this.canvas = c.getContext("2d");

      Storage.get(audioFile)
        .then(
          (result) => {
            // console.log("Storage get", result);

            setupSample(result)
              .then((sample) => {
                // console.log("sample ", sample);

                let origSignal = sample.getChannelData(0);
                var signal;

                // Define the start and end times (in seconds)
                if (audioFile[5] == "P" | audioFile[0] == "p") {
                    var {fileUnixTime, sampleRate, duration} = extractFileInfo(audioFile);
                    var isoTimeSeconds = Math.floor(Date.parse(this.hits[index].dt) / 1000);
                    var diffSeconds = isoTimeSeconds - fileUnixTime;
                    // Define the start and end times (in seconds)
                    
                    var offsetSeconds = (this.clipSeconds - 3) / 2;
                    if (offsetSeconds < 0) offsetSeconds = 0;
                    var startTime = diffSeconds - offsetSeconds; // Start at diffseconds second
                    if (startTime < 0) startTime = 0;
                    // console.log(this.clipSeconds, duration);
                    if (this.clipSeconds == duration) startTime = 0;
                    var endTime = startTime + this.clipSeconds;   // End at + clipSeconds
                    

                    // Convert time to sample indices
                    sampleRate = sample.sampleRate;
                    var startSample = Math.floor(startTime * sampleRate);
                    var endSample = Math.floor(endTime * sampleRate);

                    // console.log(this.hits[index].dt, isoTimeSeconds, fileUnixTime, diffSeconds, startTime, endTime, startSample, endSample);

                    // check if playback beyond end of clip
                    if(endSample > sample.length) {
                      endSample = sample.length - 1;
                      startSample = endSample - (this.clipSeconds * sampleRate);
                      if (startSample < 0) startSample = 0;
                    }
                    
                    // console.log("start", startSample);
                    // console.log("end", endSample);

                    signal = origSignal.slice(startSample, endSample);
                  }
                  else{
                    signal = origSignal;
                  }

                // console.log("samples", origSignal.length, this.hits[index].dt, fileUnixTime, diffSeconds);

                let overlap = 0.0;
                let fftLength = this.fftLength;
                let halfLength = this.halfLength; // chop off top

                let showLength = halfLength - Math.round(0.2 * halfLength);
                let zmidVal = -90;
                // console.log(audioFile)
                if (audioFile[5] == "2") {
                  showLength = halfLength - Math.round(0.48 * halfLength);
                  zmidVal = -66;
                }
                if (audioFile[5] == "P" | audioFile[0] == "p") {
                  showLength = halfLength - Math.round(0.48 * halfLength);
                  zmidVal = -34;
                }

                let offset = Math.floor(fftLength * (1.0 - overlap));
                // console.log("offset", offset);
                // let ctx = this.canvas;
                let fft = new FFT(fftLength, 44100);

                var spectrogramArray = [];
                for (var x = 0; x < signal.length - fftLength; x += offset) {
                  var chunk = signal.slice(x, x + fftLength);
                  for (var i = 0; i < fftLength; i++) {
                    chunk[i] = chunk[i] * hann[i];
                  }
                  fft.forward(chunk);
                  chunk = fft.spectrum.slice(0, showLength);
                  // console.log("fft", chunk);
                  var dBmag = chunk.map(linear2Decibel);
                  // console.log("dB", dBmag);
                  spectrogramArray.push(...dBmag);
                }

                // console.log("spectrogramArray", spectrogramArray);
                // console.log('showLength', showLength);

                // arrange spectrogram for Plotly
                var spectrogramData = [];
                for (i = 0; i < showLength; i++) {
                  // grab one element every halfLength points
                  var arr = spectrogramArray.filter(function (value, j) {
                    return j % showLength == 0;
                  });
                  // console.log(arr);
                  spectrogramData.push(arr);
                  spectrogramArray.shift(); // remove first element
                }
                // console.log("spectrogramData", spectrogramData);

                if (pageType === "Recent") {
                  this.hits[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: zmidVal,
                    },
                  ];
                  // console.log("spec", this.hits[index].spectrogram);
                  this.setWindowRecent(
                    index,
                    "spectrogram",
                    this.hits[index].spCode,
                    this.hits[index].cn
                  );
                }
                if (pageType === "All") {
                  this.seriesDaily[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: zmidVal,
                    },
                  ];
                  this.setWindowAll(
                    index,
                    "spectrogram",
                    this.seriesDaily[index].spCode,
                    this.seriesDaily[index].cn
                  );
                }

                if (pageType === "New") {
                  this.newSpeciesList[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: zmidVal,
                    },
                  ];
                  this.setWindowNew(
                    index,
                    "spectrogram",
                    this.newSpeciesList[index].spCode,
                    this.newSpeciesList[index].cn
                  );
                }

                if (pageType === "Missing") {
                  this.missingSpeciesList[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: zmidVal,
                    },
                  ];
                  this.setWindowMissing(
                    index,
                    "spectrogram",
                    this.missingSpeciesList[index].spCode,
                    this.missingSpeciesList[index].cn
                  );
                }
              })
              .catch((err) => {
                console.log(err);
                console.log("No audio", audioFile);
                // console.log("Delete index", index);
                this.snackbar = true;
                return false;
              });
          },
          (reason) => {
            // rejection
            console.log("Can't play ", reason);
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },
    wiFiText() {
      if (this.currentWiFi <= -75) return "WiFi Weak";
      if (this.currentWiFi <= -60) return "WiFi Good";
      if (this.currentWiFi == 0) return "No data";
      return "WiFi Strong";
    },
    getImageUrl(spCode) {
      var imageUrl =
        "https://haikubox-images.s3.amazonaws.com/" + spCode + ".jpeg?v=5";
      // if (
      //   (spCode == "amecro") |
      //   (spCode == "amerob") |
      //   (spCode == "bkchhi") |
      //   (spCode == "blujay") |
      //   (spCode == "carchi") |
      //   (spCode == "daijun") |
      //   (spCode == "eastow") |
      //   (spCode == "fiscro") |
      //   (spCode == "houfin") |
      //   (spCode == "houspa") |
      //   (spCode == "moudov") |
      //   (spCode == "norcar") |
      //   (spCode == "pilwoo") |
      //   (spCode == "reshaw")
      // ) {
      //   imageUrl =
      //     "https://haikubox-images.s3.amazonaws.com/" + spCode + "H.jpg";
      // }
      // console.log(imageUrl);
      return imageUrl;
    },
    updateCurrentHaikuboxRadius() {
      // console.log('current zoom', this.currentZoom);
      this.currentHaikuboxRadius = 20000 / this.currentZoom;
      // var radiusIncrement = 40000;
      // var markerThreshold = 400000;
      if (this.currentZoom <= 4) {
        this.currentHaikuboxRadius = 40000;
      }
      if (this.currentZoom == 5) {
        this.currentHaikuboxRadius = 20000;
      }
      // if (this.currentZoom == 6) {
      //   markerThreshold = 80000;
      //   radiusIncrement = 8000;
      // }
      // if (this.currentZoom == 7) {
      //   markerThreshold = 40000;
      //   radiusIncrement = 4000;
      // }
      // if (this.currentZoom == 8) {
      //   markerThreshold = 30000;
      //   radiusIncrement = 3000;
      // }
      // if (this.currentZoom == 9) {
      //   markerThreshold = 20000;
      //   radiusIncrement = 2000;
      // }
      // if (this.currentZoom == 10) {
      //   markerThreshold = 10000;
      //   radiusIncrement = 1000;
      // }
      // if (this.currentZoom == 11) {
      //   markerThreshold = 3000;
      //   radiusIncrement = 300;
      // }
      // if (this.currentZoom == 12) {
      //   markerThreshold = 1000;
      //   radiusIncrement = 100;
      // }
      // if (this.currentZoom >= 13) {
      //   markerThreshold = 500;
      //   radiusIncrement = 50;
      // }
      // this.currentHaikuboxRadius += radiusIncrement;
      // if (this.currentHaikuboxRadius > markerThreshold)
      //   this.currentHaikuboxRadius = 0;
      // // console.log("updateCurrentHaikuboxRadius", this.currentZoom);
      // this.haikuboxMarkerID += 1; // force redraw
      // console.log(this.currentZoom);
      // if (this.showMap) setTimeout(this.updateCurrentHaikuboxRadius, 200);
    },
    // async loadSummary(serial) {
    //   var tempSummary = [];
    //   // var colorMap = ['#ffffcc','#c7e9b4','#7fcdbb','#41b6c4','#2c7fb8','#253494'];

    //   // load past day first so fast to load, then load beyond that
    //   var startDate = moment.utc().subtract(24, "hours").format();
    //   const queryHitSummary = await API.graphql({
    //     query: hitSummaryBySerialByDate,
    //     variables: {
    //       serial: serial,
    //       dt: { ge: startDate },
    //     },
    //   });
    //   tempSummary = tempSummary.concat(
    //     queryHitSummary.data.hitSummaryBySerialByDate.items
    //   );
    //   // console.log("1 day tempSummary", tempSummary);

    //   // parse by species and total
    //   // goal is list of objects
    //   // [ { Bluejay: [0,0,12,12,43,54,]},
    //   //   {American Goldfinch: [ 0, 0, 123,34,324,]}]

    //   var species15MinuteCounts = {};
    //   // empty list
    //   let n = 24 * 4; // every 15 minutes for 24 hours
    //   let a = new Array(n);
    //   for (let i = 0; i < n; ++i) a[i] = 0;
    //   species15MinuteCounts["dt"] = a;

    //   async function createEmptyLists() {
    //     // set up keys with empty lists
    //     for (let item in tempSummary) {
    //       let speciesCount = JSON.parse(tempSummary[item].name);
    //       // console.log('speciesCount', speciesCount);
    //       for (var key in speciesCount) {
    //         species15MinuteCounts[key] = a.slice();
    //       }
    //     }
    //   }

    //   async function fillList() {
    //     var tempArray;
    //     for (let item in tempSummary) {
    //       tempArray = species15MinuteCounts["dt"].slice();
    //       tempArray[item] = tempSummary[item].dt;
    //       species15MinuteCounts["dt"] = tempArray.slice();
    //       let speciesCount = JSON.parse(tempSummary[item].name);
    //       for (var key in speciesCount) {
    //         // console.log("item key count", item, key, speciesCount[key]);
    //         tempArray = species15MinuteCounts[key].slice();
    //         tempArray[item] = speciesCount[key];
    //         species15MinuteCounts[key] = tempArray.slice();
    //       }
    //     }
    //   }
    //   await createEmptyLists();
    //   await fillList();

    //   // console.log("species15MinuteCounts", species15MinuteCounts);

    //   var species1HourCounts = {};

    //   for (var key in species15MinuteCounts) {
    //     // console.log(key, species15MinuteCounts[key]);
    //     var tempArray4 = [];
    //     var tempArray = species15MinuteCounts[key].slice();
    //     for (let i = 0; i < n; i += 4) {
    //       if (key == "dt") {
    //         tempArray4.push(tempArray[i]);
    //       } else {
    //         tempArray4.push(
    //           tempArray[i] +
    //             tempArray[i + 1] +
    //             tempArray[i + 2] +
    //             tempArray[i + 3]
    //         );
    //       }
    //     }
    //     species1HourCounts[key] = tempArray4.slice();
    //   }
    //   // console.log("species1HourCounts", species1HourCounts);
    //   this.species1HourCounts = species1HourCounts;

    //   var nextToken = null;
    //   startDate = moment.utc().subtract(60, "days").format();
    //   tempSummary = [];
    //   do {
    //     const queryHitSummary = await API.graphql({
    //       query: hitSummaryBySerialByDate,
    //       variables: {
    //         serial: serial,
    //         dt: { gt: startDate },
    //         nextToken: nextToken,
    //       },
    //     });
    //     tempSummary = tempSummary.concat(
    //       queryHitSummary.data.hitSummaryBySerialByDate.items
    //     );
    //     nextToken = queryHitSummary.data.hitSummaryBySerialByDate.nextToken;
    //   } while (nextToken != null);

    //   // console.log("tempSummary", tempSummary);
    //   var fifteenMinuteCountPlot = [];
    //   for (let item in tempSummary) {
    //     let dateText = moment(tempSummary[item].createdAt)
    //       .local()
    //       .format("YYYY-MM-DD HH:mm");
    //     fifteenMinuteCountPlot.push([dateText, tempSummary[item].count]);
    //   }
    //   // console.log("fifteenMinuteCount", fifteenMinuteCountPlot);
    //   this.fifteenMinuteCountPlot = fifteenMinuteCountPlot;

    //   const fusionDataStore = new FusionCharts.DataStore();
    //   // After that we are creating a DataTable by passing our data and schema as arguments
    //   const fusionTable = fusionDataStore.createDataTable(
    //     fifteenMinuteCountPlot,
    //     this.fusionSchema
    //   );
    //   // After that we simply mutated our timeseries datasource by attaching the above
    //   // DataTable into its data property.
    //   this.dataSource.data = fusionTable;
    // },
    filterHourlySummary(showHour) {
      // if (this.animationRunning==false) this.sliderSummaryHourIndex();
      const filteredSummary = this.hourlySummary.filter(function (el) {
        // if (el.hour == showHour) console.log('el', el);
        return el.hour == showHour;
      });
      // console.log('filterHourlySummary', showHour, filteredSummary);
      this.summaryHourLabel = filteredSummary[0].datetime;
      return filteredSummary;
    },
    incrementHour() {
      var tempSummaryHour = this.summaryHour + 1;
      if (tempSummaryHour == 24) tempSummaryHour = 0;
      this.summaryHour = tempSummaryHour;
    },
    toggleBasemap() {
      if (
        this.urlSummary ==
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}"
      )
        this.urlSummary =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}";
      else
        this.urlSummary =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}";
    },
    toggleColormap() {
      let tempIndex = this.summaryColorMapIndex + 1;
      if (this.summaryColorMapIndex == 5) tempIndex = 0;
      this.summaryColorMapIndex = tempIndex;
    },
    startAnimation() {
      if (this.animationRunning) return;
      this.animationInterval = setInterval(this.incrementHour, 500);
      this.animationRunning = true;
    },
    stopAnimation() {
      if (this.animationRunning) {
        clearInterval(this.animationInterval);
        this.animationRunning = false;
      }
    },
    sliderSummaryHourIndex() {
      // map slider values from 0 to 23, so that 23 is latest time and 0 is earliest
      var currentHour = moment.utc().hours() - 1;
      if (currentHour < 0) currentHour = 23;
      var maxSliderCorrection = 23 - currentHour;
      var tempSummaryHour = this.summaryHourIndex - maxSliderCorrection;
      if (tempSummaryHour < 0) tempSummaryHour = tempSummaryHour + 24;
      this.summaryHour = tempSummaryHour;
    },
    labelText(spCode, commonName) {
      let cn = this.t(spCode, commonName);
      // console.log(spCode, cn);
      return this.t("Is") + " " + cn + " " + this.t("Correct") + "?";
    },
    subscribe(serialClicked) {
      if (subscription) {
        // console.log("unsubscribing");
        subscription.unsubscribe();
      }
      // console.log("subscribe");
      subscription = API.graphql({
        query: onCreateHit,
        variables: { serial: serialClicked },
      }).subscribe({
        next: (eventData) => {
          // console.log(eventData);
          let liveHit = eventData.value.data.onCreateHit;
          if (liveHit.specSum <= this.specSumThreshold) return;
          if (liveHit.score <= this.confidenceThreshold) return;
          if (this.hiddenList.includes(liveHit.cn)) return;
          if (liveHit.cn === "soundscape") return;
          if (this.liveHits.some((item) => item.id === liveHit.id)) return; // remove duplications
          this.liveHits = [liveHit, ...this.liveHits];
          this.liveHits = this.liveHits.slice(0, 20); // limit to 20 hits
          this.lastUpdated = moment
            .utc()
            .local()
            .locale(this.selectedLanguage)
            .calendar();
        },
      });
    },
    async logClick(clickTarget, spCode, cn) {
      const userID = this.user;
      const serial = this.currentSerial;
      const pageClickedFrom = this.currentView;

      // createdAt
      const clickData = {
        userID,
        serial,
        spCode,
        cn,
        clickTarget,
        pageClickedFrom,
      };

      await API.graphql({
        query: createClickTable,
        variables: { input: clickData },
      });
    },
    async shareLink(spCode, commonName, audioFile) {
      this.logClick("shareLink", "", commonName);
      var audioFileParts = audioFile.split("/").pop();
      // console.log('shareLink', audioFileParts);
      this.audioLink =
        "https://haikubox.social/" + audioFileParts.slice(0, -4) + "html";

      // this is link for downloading file that is created in haikubox.social
      this.downloadLink =
        "https://haikubox.social/public/tweet/" +
        this.audioLink.slice(24, -4) +
        "flac";

      var dest = "tweet/" + audioFile.slice(0, -4) + "txt";
      // html web page gets generated when new audio file saved in s3 haikubox.social
      this.shareCommonName = commonName;
      this.shareAudioFile = audioFile;
      await Storage.put(dest, commonName);
    },
    async copyLink() {
      this.logClick("copyLink");
      this.copyLinkSnackbar = true;
      await navigator.clipboard.writeText(this.audioLink);
    },
    async toggleShowBird(cn, spCode, showBird) {
      let id = this.currentSerial + "_" + spCode;
      this.logClick("hideBird" + "_" + showBird, spCode, cn);
      let serial = this.currentSerial;
      const hideBirdData = {
        id,
        spCode,
        cn,
        serial,
      };
      // console.log('toggleShowBird', hideBirdData);
      if (showBird == true) {
        await API.graphql({
          query: deleteHideBird,
          variables: { input: { id: id } },
        });
      }
      if (showBird == false) {
        await API.graphql({
          query: createHideBird,
          variables: { input: hideBirdData },
        });
      }
    },
    async toggleNewBirdAlert(newBirdAlert) {
      // update device table
      var id = this.currentSerial.split("_");
      this.logClick("toggleNewBirdAlert" + "_" + newBirdAlert, null, null);
      // console.log('toggleNewBirdAlert', this.currentSerial);
      await API.graphql({
        query: updateDevice,
        variables: { input: { id: id[1], newBirdAlert: newBirdAlert } },
      });
      if (newBirdAlert == true) {
        // console.log("notify check notifications on", deviceInfo);
        if (this.osConsentGranted === false) {
          this.notifyBirdInfo = true;
          // notifyBirdInfoSnackShown will show for each notify clicked if on Pause
          // this.notifyBirdInfoSnackShown = true;
        }
      }
    },
    async toggleNotifyBird(cn, spCode, notifyBird) {
      let id = this.currentSerial + "_" + spCode;
      this.logClick("notifyBird" + "_" + notifyBird, spCode, cn);
      let serial = this.currentSerial;
      const notifyBirdData = {
        id,
        spCode,
        cn,
        serial,
      };
      // console.log("toggleNotifyBird", notifyBirdData);
      if (notifyBird == false) {
        await API.graphql({
          query: deleteNotifyBird,
          variables: { input: { id: id } },
        });
      }
      if (notifyBird == true) {
        await API.graphql({
          query: createNotifyBird,
          variables: { input: notifyBirdData },
        });

        if (this.osConsentGranted === false) {
          this.notifyBirdInfo = true;
          // notifyBirdInfoSnackShown will show for each notify clicked if on Pause
          // this.notifyBirdInfoSnackShown = true;
        }
      }
      // console.log('notifySnackShown', this.notifyBirdInfoSnackShown);
    },
    async toggleHaikuboxBookmark() {
      if (this.currentSerial === "") return;
      this.currentHaikuboxBookmark = !this.currentHaikuboxBookmark;
      // create or delete bookmark from bookmarkHaikubox
      let id = this.currentSerial + "_" + this.user;
      this.logClick(
        "toggleHaikuboxBookmark" + "_" + this.currentSerial,
        null,
        null
      );
      let serial = this.currentSerial;
      let owner = this.user;
      const bookmarkHaikuboxData = {
        id,
        serial,
        owner,
      };
      // console.log("toggleHaikuboxBookmark", bookmarkHaikuboxData);
      // console.log('toggleNotifyBird', id);
      if (this.currentHaikuboxBookmark == false) {
        await API.graphql({
          query: deleteBookmarkHaikubox,
          variables: { input: { id: id } },
        });
      }

      if (this.currentHaikuboxBookmark == true) {
        await API.graphql({
          query: createBookmarkHaikubox,
          variables: { input: bookmarkHaikuboxData },
        });
      }
      // update list
      this.loadBookmarkedHaikuboxes();
      // this.bookmarkHaikuboxKey += 1;
    },
    async downloadCSV() {
      if (this.downloadRaw) {
        this.logClick("downloadRaw", "", "");
        // console.log(this.csvDates.length);
        // if only pick one day add one to start for end
        if (this.csvDates.length == 1) {
          // console.log("second date not selected");
          let startDate = moment(this.csvDates[0]);
          this.csvDates[1] = startDate.add(1, "d").format("YYYY-MM-DD");
        }

        var b = moment(this.csvDates[0]);
        var a = moment(this.csvDates[1]);
        let diffDays = a.diff(b, "days"); // 1
        // console.log("number of days", diffDays);
        if (diffDays > 31) return;
      }

      this.csvDialog = false;

      if (this.downloadSummary) {
        this.logClick("downloadSummary", "", "");
        // Empty array for storing the values
        let csvRows = "Species,Count\n";
        // const values = Object.values(this.seriesDaily).join(',');
        // csvRows.push(values);
        for (let i in this.seriesDaily) {
          csvRows +=
            this.t(this.seriesDaily[i].spCode) +
            "," +
            this.seriesDaily[i].countsTotal +
            "\n";
        }

        // Creating a Blob for having a csv file format
        // and passing the data with type
        const blob = new Blob([csvRows], { type: "text/csv" });

        // Creating an object for downloading url
        const url = window.URL.createObjectURL(blob);

        // Creating an anchor(a) tag of HTML
        const a = document.createElement("a");

        // Passing the blob downloading url
        a.setAttribute("href", url);

        // Setting the anchor tag attribute for downloading
        // and passing the download file name
        a.setAttribute("download", this.currentSiteName + ".csv");

        // Performing a download with click
        a.click();
      }

      if (this.downloadRaw) {
        // Empty array for storing the values
        let csvRows =
          "Species,Scientific Name,UTC Date,Local Date,Local Time,Score,Count\n";

        // Big Query of Hit Table
        var nextToken = null;
        // console.log("Yesterday", yesterdayDate)
        var tempHits = [];
        // console.log("csv range", this.csvDates);
        var queryCounter = 0;
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: this.currentSerial,
              dt: { between: this.csvDates },
              sortDirection: "DESC",
              filter: { group: { eq: "bird" }, specSum: { gt: 1 } },
              nextToken: nextToken,
            },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = queryCounter;
          queryCounter++;
          if (queryCounter > 1000) break;
        } while (nextToken != null);
        this.hitsLoading = 0;

        // console.log('csv export tempHits', tempHits);
        for (let i in tempHits) {
          let localTimeStr = moment
            .utc(tempHits[i].dt)
            .tz(this.currentTimezone)
            .format("HH:mm:ss");
          let localDateStr = moment
            .utc(tempHits[i].dt)
            .tz(this.currentTimezone)
            .format("DD-MMM-YYYY");
          csvRows +=
            this.t(tempHits[i].spCode) +
            "," +
            tempHits[i].sn +
            "," +
            tempHits[i].dt +
            "," +
            localDateStr +
            "," +
            localTimeStr +
            "," +
            tempHits[i].score +
            "," +
            tempHits[i].detectionCount +
            "\n";
        }

        // Creating a Blob for having a csv file format
        // and passing the data with type
        const blob = new Blob([csvRows], { type: "text/csv" });

        // Creating an object for downloading url
        const url = window.URL.createObjectURL(blob);

        // Creating an anchor(a) tag of HTML
        const a = document.createElement("a");

        // Passing the blob downloading url
        a.setAttribute("href", url);

        // Setting the anchor tag attribute for downloading
        // and passing the download file name
        a.setAttribute("download", this.currentSiteName + "_raw.csv");

        // Performing a download with click
        a.click();
      }
    },
    selectSpecies(species) {
      // console.log('selectSpecies', species);
      // janky way to make sure scrolling goes to right location
      if (this.scrolledToBottom == false) {
        window.scrollTo(0, document.documentElement.scrollHeight, "instant"); // scroll to bottom first
        this.scrolledToBottom = true;
      }
      var targetElement = document.getElementById(species);
      var targetScrollPosition = targetElement.offsetTop + 80;
      window.scrollTo({
        top: targetScrollPosition,
        behavior: "smooth", // You can use 'auto' for instant scrolling
      });
    },
    async favoriteHit(item) {
      // console.log("favoriteHit", item);
      item.favoriteHit = !item.favoriteHit;
      item.id = item.id + 1;
      // console.log("favoriteHit", item.favoriteHit);
      // if hit already in table, delete it
      try {
        const favoriteReturn = await API.graphql({
          query: getFavoriteHit,
          variables: {
            id: item.currentWav["filename"],
          },
        });
        // console.log(item.id, favoriteReturn);
        const id = item.currentWav["filename"];
        if (favoriteReturn.data.getFavoriteHit != null) {
          await API.graphql({
            query: deleteFavoriteHit,
            variables: { input: { id: id } },
          });
        } else {
          // if not in table, copy flac to wav using lambda copyWav
          // Copies 'existing/srcKey' to 'copied/destKey' from 'public' to 'private'
          await Storage.copy(
            { key: item.wav, level: "public" },
            { key: item.wav, level: "private" }
          );
          // console.log("copied", copied);

          const id = item.currentWav["filename"];
          const serial = item.serial;
          const owner = this.user;
          const dt = item.currentWav["dt"];
          const animalGroup = item.group;
          const cn = item.cn;
          const sn = item.sn;
          const spCode = item.spCode;
          const wav = item.currentWav["filename"];
          const score = item.currentWav["score"];
          const specSum = item.currentWav["specSum"];

          const favoriteData = {
            id,
            serial,
            owner,
            dt,
            animalGroup,
            cn,
            sn,
            spCode,
            wav,
            score,
            specSum,
          };

          await API.graphql({
            query: createFavoriteHit,
            variables: { input: favoriteData },
          });
        }
      } catch (err) {
        console.log("getFavoriteHit failed");
      }
    },
    moveUp() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
@import url("https://fonts.googleapis.com/css?family=Quicksand");
#haikubox {
  font-family: Quicksand, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 0;
  box-sizing: border-box;  */
}
header {
  font-family: Quicksand;
  /* display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background-color: #212121;
  color: #fff; */
}
main {
  min-height: 100%;
  overflow: hidden;
  /* background-color: #ffe; */
  justify-content: center;
  align-items: center;
}
.v-menu__content {
  max-height: 600px !important; /* Set the max-height as needed */
}
</style>
